"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7300],{

/***/ 73559:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var ChangeCover = function(cover) {
    if (!cover) return cover;
    var changedCoverUrl = cover;
    if (changedCoverUrl.match(/^http:\/\/stealth-test-files/i)) {
        changedCoverUrl = changedCoverUrl.replace("http://stealth-test-files", "https://stealth-test-files.s3-eu-west-1.amazonaws.com");
    }
    var regexPublish = /^(http|https):\/\/storage.publish.streetlib.com(.s3.amazonaws.com|)/;
    if (changedCoverUrl.match(regexPublish)) {
        changedCoverUrl = changedCoverUrl.replace(regexPublish, "https://s3-publish.streetlib.com");
    }
    var regexSbf = /^(http|https):\/\/storage.sbfstealth.com(.s3.amazonaws.com|)/;
    if (changedCoverUrl.match(regexSbf)) {
        changedCoverUrl = changedCoverUrl.replace(regexSbf, "https://s3-publish.streetlib.com");
    }
    return changedCoverUrl;
};
/* harmony default export */ __webpack_exports__["Z"] = (ChangeCover);


/***/ }),

/***/ 17300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var dist_index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/theme/card/index.js
var card = __webpack_require__(16850);
// EXTERNAL MODULE: ./src/redux/action/history.js
var action_history = __webpack_require__(14758);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/redux/reselect/history.js
/* eslint-disable camelcase */ 



var selectPublishingHistory = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.history.payload;
}, function(payload) {
    var data = payload.data;
    if (!data) return [];
    return data.items.map(function(item) {
        var result = {};
        var isbn = item.isbn, title = item.title, cover_url = item.cover_url, platforms = item.platforms;
        platforms.forEach(function(platform) {
            result.platforms = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result.platforms), (0,_define_property/* default */.Z)({}, platform.name, platform));
        });
        result = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
            id: isbn,
            title: title,
            cover: cover_url
        });
        return result;
    });
});
/* harmony default export */ var reselect_history = (selectPublishingHistory);

// EXTERNAL MODULE: ./src/redux/reselect/profile.js
var profile = __webpack_require__(95293);
;// CONCATENATED MODULE: ./src/theme/icons/distribute.js
/* eslint-disable react-hooks/rules-of-hooks */ 



var distribute = function(param) {
    var disabled = param.disabled, _width = param.width, width = _width === void 0 ? "18" : _width, color = param.color;
    var theme = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
    var colorMemo = (0,react.useMemo)(function() {
        if (color) {
            return (0,index_esm/* themeGet */.R)("colors.".concat(color))({
                theme: theme
            });
        }
        return disabled ? "grey_200" : (0,index_esm/* themeGet */.R)("colors.distribute")({
            theme: theme
        });
    }, [
        theme,
        disabled,
        color
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M1.8 0.947266H16.2C17.1927 0.947266 18 1.75457 18 2.74727V4.54727C18 5.20967 17.6355 5.78477 17.1 6.09707V15.3473C17.1 16.34 16.2927 17.1473 15.3 17.1473H2.7C1.7073 17.1473 0.9 16.34 0.9 15.3473V6.09707C0.3645 5.78477 0 5.20967 0 4.54727V2.74727C0 1.75457 0.8073 0.947266 1.8 0.947266ZM16.2 2.74727H1.8V4.54727H16.2018L16.2 2.74727ZM2.7 6.34727V15.3473H15.3018L15.3 6.34727H2.7ZM12.6 8.14736H5.40001V9.94736H12.6V8.14736Z",
                    fill: colorMemo
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(0 0.0473633)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_distribute = (distribute);

;// CONCATENATED MODULE: ./src/theme/icons/print.js
/* eslint-disable react-hooks/rules-of-hooks */ 



var print = function(param) {
    var disabled = param.disabled, _width = param.width, width = _width === void 0 ? "18" : _width, color = param.color;
    var theme = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
    var colorMemo = (0,react.useMemo)(function() {
        if (color) {
            return (0,index_esm/* themeGet */.R)("colors.".concat(color))({
                theme: theme
            });
        }
        return disabled ? "grey_200" : (0,index_esm/* themeGet */.R)("colors.print")({
            theme: theme
        });
    }, [
        theme,
        disabled,
        color
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.4 4.54736H15.3C16.7886 4.54736 18 5.75876 18 7.24736V13.5474C18 14.5401 17.1927 15.3474 16.2 15.3474H14.4V18.0474H3.6V15.3474H1.8C0.8073 15.3474 0 14.5401 0 13.5474V7.24736C0 5.75876 1.2114 4.54736 2.7 4.54736H3.6V0.0473633H14.4V4.54736ZM12.6 1.84736H5.4V4.54736H12.6V1.84736ZM5.4 16.2474H12.6V12.6474H5.4V16.2474ZM14.4 13.5474H16.2V7.24736C16.2 6.75146 15.7968 6.34736 15.3 6.34736H2.7C2.2041 6.34736 1.8 6.75146 1.8 7.24736V13.5474H3.6V10.8474H14.4V13.5474ZM14.4 7.24746H10.8V9.04746H14.4V7.24746Z",
                    fill: colorMemo
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(0 0.0473633)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_print = (print);

;// CONCATENATED MODULE: ./src/theme/publish-card/index.js
/* eslint-disable jsx-a11y/anchor-is-valid */ 


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: row;\n  border-bottom: 2px solid ",
        ";\n  background: ",
        ";\n\n  & > img {\n    width: 40px;\n    min-width: 40px;\n    height: 66px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding-left: ",
        "px;\n\n  & > .actions {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n\n    & > .action-btn {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 38px;\n      height: 38px;\n      margin-right: ",
        "px;\n      cursor: pointer;\n    }\n\n    & > span.action-btn {\n      cursor: default;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  user-select: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* stylelint-disable */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  /* stylelint-enable */\n  -webkit-line-clamp: 2;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a2e665-0"
})(_templateObject(), dist_index_esm/* space */.Dh, (0,index_esm/* themeGet */.R)("colors.primary_50"), (0,index_esm/* themeGet */.R)("colors.white"));
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a2e665-1"
})(_templateObject1(), (0,index_esm/* themeGet */.R)("space.xs"), (0,index_esm/* themeGet */.R)("space.xxs"));
var Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-5a2e665-2"
})(_templateObject2(), dist_index_esm/* typography */.cp, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh, dist_index_esm/* layout */.bK);
var Cover = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-5a2e665-3"
})(_templateObject3());
/* WRITE WAS REMOVED WE NEED TO COMPLETE API FOR IT */ /*
  {payload.platforms.WRITE.item_url ? (
    <a className="action-btn" title="write" href={payload.platforms.WRITE.item_url}>
      <Write />
    </a>
  ) : (
    <span className="action-btn">
      <Write color="grey_200" />
    </span>
  )}
*/ function PublishCard(param) {
    var style = param.style, payload = param.payload, error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        p: "xs",
        mb: "xs"
    }, style), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {
                src: error ? "/images/book-error.jpg" : payload.cover || "/images/book.jpg",
                alt: "copertina"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "actions",
                        children: [
                            payload.platforms.PUBLISH.item_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "action-btn",
                                title: "distribute",
                                href: payload.platforms.PUBLISH.item_url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_distribute, {})
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "action-btn",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_distribute, {
                                    color: "grey_200"
                                })
                            }),
                            payload.platforms.POS.item_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "action-btn",
                                title: "print",
                                href: payload.platforms.POS.item_url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_print, {})
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "action-btn",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_print, {
                                    color: "grey_200"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        fontSize: [
                            "pSmall",
                            "pSmall",
                            "pSmall",
                            "h3"
                        ],
                        lineHeight: [
                            "pSmall",
                            "pSmall",
                            "pSmall",
                            "h3"
                        ],
                        fontWeight: "normal",
                        ml: "xs",
                        height: [
                            "40px",
                            "40px",
                            "40px",
                            "42px"
                        ],
                        color: "grey_600",
                        children: !error ? payload.title : "error"
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var publish_card = (PublishCard);

// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
;// CONCATENATED MODULE: ./src/theme/card-placeholder/index.js



function card_placeholder_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: row;\n  border-bottom: 2px solid ",
        ";\n  background: ",
        ";\n\n  & > img {\n    width: 40px;\n    min-width: 40px;\n    height: 66px;\n  }\n"
    ]);
    card_placeholder_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function card_placeholder_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  flex: 1;\n  padding-left: ",
        "px;\n"
    ]);
    card_placeholder_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function card_placeholder_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n"
    ]);
    card_placeholder_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var card_placeholder_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b63f190a-0"
})(card_placeholder_templateObject(), dist_index_esm/* space */.Dh, (0,index_esm/* themeGet */.R)("colors.primary_50"), (0,index_esm/* themeGet */.R)("colors.white"));
var card_placeholder_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b63f190a-1"
})(card_placeholder_templateObject1(), (0,index_esm/* themeGet */.R)("space.xs"));
var card_placeholder_Cover = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-b63f190a-2"
})(card_placeholder_templateObject2());
function CardPlaceholder(param) {
    var style = param.style;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_placeholder_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        p: "xs",
        mb: "xs"
    }, style), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card_placeholder_Cover, {
                src: "/images/book-placeholder.jpg",
                alt: "Book cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card_placeholder_Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: [
                        "h3",
                        "h3",
                        "h3",
                        "h2"
                    ],
                    lineHeight: [
                        "h3",
                        "h3",
                        "h3",
                        "h2"
                    ],
                    fontWeight: "normal",
                    ml: "xs",
                    children: translations/* default */.Z[languageCode]["no available"]
                })
            })
        ]
    }));
}
/* harmony default export */ var card_placeholder = (CardPlaceholder);

// EXTERNAL MODULE: ./node_modules/react-content-loader/dist/react-content-loader.es.js
var react_content_loader_es = __webpack_require__(24561);
;// CONCATENATED MODULE: ./src/theme/content-loader/cards.js






function CardContentLoader(param) {
    var maxWidth = param.maxWidth, speed = param.speed, backgroundColor = param.backgroundColor, foregroundColor = param.foregroundColor;
    var theme = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                maxWidth: maxWidth,
                width: "100%",
                height: "96px",
                bg: "white",
                border: "none",
                p: "xs",
                mb: "xxxs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_content_loader_es/* default */.ZP, {
                    speed: speed || 2,
                    width: "220",
                    height: "84",
                    viewBox: "0 0 220 84",
                    backgroundColor: backgroundColor || (0,index_esm/* themeGet */.R)("colors.primary_100")({
                        theme: theme
                    }),
                    foregroundColor: foregroundColor || (0,index_esm/* themeGet */.R)("colors.primary_50")({
                        theme: theme
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "40",
                            height: "66"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "66",
                            y: "20",
                            rx: "5",
                            ry: "5",
                            width: "120",
                            height: "12"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "66",
                            y: "40",
                            rx: "5",
                            ry: "5",
                            width: "50",
                            height: "12"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                maxWidth: maxWidth,
                width: "100%",
                height: "96px",
                bg: "white",
                border: "none",
                p: "xs",
                mb: "xxxs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_content_loader_es/* default */.ZP, {
                    speed: speed || 2,
                    width: "220",
                    height: "84",
                    viewBox: "0 0 220 84",
                    backgroundColor: backgroundColor || (0,index_esm/* themeGet */.R)("colors.primary_100")({
                        theme: theme
                    }),
                    foregroundColor: foregroundColor || (0,index_esm/* themeGet */.R)("colors.primary_50")({
                        theme: theme
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "40",
                            height: "66"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "66",
                            y: "20",
                            rx: "5",
                            ry: "5",
                            width: "120",
                            height: "12"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "66",
                            y: "40",
                            rx: "5",
                            ry: "5",
                            width: "50",
                            height: "12"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                maxWidth: maxWidth,
                width: "100%",
                height: "96px",
                bg: "white",
                border: "none",
                p: "xs",
                mb: "xxxs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_content_loader_es/* default */.ZP, {
                    speed: speed || 2,
                    width: "220",
                    height: "84",
                    viewBox: "0 0 220 84",
                    backgroundColor: backgroundColor || (0,index_esm/* themeGet */.R)("colors.primary_100")({
                        theme: theme
                    }),
                    foregroundColor: foregroundColor || (0,index_esm/* themeGet */.R)("colors.primary_50")({
                        theme: theme
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "40",
                            height: "66"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "66",
                            y: "20",
                            rx: "5",
                            ry: "5",
                            width: "120",
                            height: "12"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "66",
                            y: "40",
                            rx: "5",
                            ry: "5",
                            width: "50",
                            height: "12"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var cards = (CardContentLoader);

// EXTERNAL MODULE: ./src/theme/link/external-link.js
var external_link = __webpack_require__(55431);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./src/lib/get-platform-urls.js

// Return platform urls from abilities
var getPlatformUrls = function(abilities) {
    var platformWrite = lodash_default().find(abilities, {
        platform: {
            name: "WRITE"
        }
    });
    var platformPublish = lodash_default().find(abilities, {
        platform: {
            name: "PUBLISH"
        }
    });
    var platformDistribution = lodash_default().find(abilities, {
        platform: {
            name: "DISTRIBUTION"
        }
    });
    var platformPrint = lodash_default().find(abilities, {
        platform: {
            name: "POS"
        }
    });
    var shufflePublish = lodash_default().find(abilities, {
        platform: {
            name: "SHUFFLE_PUBLISH"
        }
    });
    var shufflePrint = lodash_default().find(abilities, {
        platform: {
            name: "SHUFFLE_POS"
        }
    });
    var showWrite = platformWrite && platformWrite.enabled && platformWrite.visible || false;
    var showPublish = platformPublish && platformPublish.enabled || false;
    var showDistribution = platformDistribution && platformDistribution.enabled && platformDistribution.visible || false;
    var showPrint = platformPrint && platformPrint.enabled || false;
    // const showShufflePublish = shufflePublish && shufflePublish.enabled && shufflePublish.visible || false;
    // const showShufflePrint = shufflePrint && shufflePrint.enabled && shufflePrint.visible || false;
    var platformUrls = {
        write: null,
        publish: shufflePublish && shufflePublish.platform ? shufflePublish.platform.url : null,
        print: shufflePrint && shufflePrint.platform ? shufflePrint.platform.url : null
    };
    if (showWrite) platformUrls.write = platformWrite.platform.url;
    if (showPublish && !showDistribution) platformUrls.publish = platformPublish.platform.url;
    else if (showPublish && showDistribution) platformUrls.publish = platformDistribution.platform.url;
    else if (showDistribution) platformUrls.publish = platformDistribution.platform.url;
    if (showPrint && !showDistribution) platformUrls.print = platformPrint.platform.url;
    else if (showPrint && showDistribution) platformUrls.print = platformDistribution.platform.url;
    return platformUrls;
};
/* harmony default export */ var get_platform_urls = (getPlatformUrls);

;// CONCATENATED MODULE: ./src/components/publishing-history/index.js
/* eslint-disable no-nested-ternary */ 
function publishing_history_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    publishing_history_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function publishing_history_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n"
    ]);
    publishing_history_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var publishing_history_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7385da7c-0"
})(publishing_history_templateObject());
var WrpLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7385da7c-1"
})(publishing_history_templateObject1());
function PublishingHistory() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.history;
    }), isWaiting = ref.isWaiting, error = ref.error;
    var publishingHistory = (0,es/* useSelector */.v9)(reselect_history);
    var payload = (0,es/* useSelector */.v9)(profile/* default */.Z).payload;
    var platformUrls = {};
    if (payload.abilities) platformUrls = get_platform_urls(payload.abilities);
    (0,react.useEffect)(function() {
        dispatch((0,action_history/* getHistoryRequest */.mL)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(publishing_history_Wrapper, {
        children: [
            isWaiting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(cards, {}) : publishingHistory.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(card_placeholder, {}) : publishingHistory.map(function(item, key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(publish_card, {
                    payload: item,
                    error: error
                }, "".concat(key, "-").concat(item.id));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrpLink, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* default */.Z, {
                    style: {
                        p: 0
                    },
                    title: translations/* default */.Z[languageCode]["view catalog"],
                    href: platformUrls.publish,
                    target: "_blank",
                    rel: "noreferrer",
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        fontSize: [
                            "pSmall",
                            "pSmall",
                            "pSmall",
                            "pLarge"
                        ],
                        lineHeight: [
                            "pSmall",
                            "pSmall",
                            "pSmall",
                            "pLarge"
                        ],
                        fontWeight: "bold",
                        children: translations/* default */.Z[languageCode]["view catalog"]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var publishing_history = (PublishingHistory);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/base-64/base64.js
var base64 = __webpack_require__(97501);
var base64_default = /*#__PURE__*/__webpack_require__.n(base64);
// EXTERNAL MODULE: ./src/redux/action/filters.js
var filters = __webpack_require__(93103);
// EXTERNAL MODULE: ./src/redux/action/aggr.js
var aggr = __webpack_require__(49888);
// EXTERNAL MODULE: ./src/lib/format-currency.js
var format_currency = __webpack_require__(70351);
// EXTERNAL MODULE: ./src/lib/change-cover-url.js
var change_cover_url = __webpack_require__(73559);
;// CONCATENATED MODULE: ./src/redux/reselect/top-selling.js
/* eslint-disable camelcase */ 




var selectTopSelling = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.aggr.payload;
}, function(_, key) {
    return key;
}, function(payload, key) {
    var result = {
        isWaiting: true,
        payload: []
    };
    if (!payload[key] || !payload[key].data) return result;
    var _key = payload[key], currency = _key.currency, isWaiting = _key.isWaiting, _data = _key.data, _aggregations = _data.aggregations, buckets = _aggregations.results.buckets;
    result.payload = buckets.map(function(bucket) {
        var id = bucket.key, include = bucket.include, current_period = bucket.current_period, previous_period = bucket.previous_period;
        var cover_link = include.hits && include.hits.hits && include.hits.hits[0] ? include.hits.hits[0]._source.cover_link : null;
        var title = include.hits && include.hits.hits && include.hits.hits[0] ? include.hits.hits[0]._source.title : null;
        var isbn = include.hits && include.hits.hits && include.hits.hits[0] ? include.hits.hits[0]._source.isbn : null;
        var totalCurrentRevenues = (0,format_currency/* default */.Z)(currency, current_period.total_revenues.value);
        var totalPreviousRevenues = (0,format_currency/* default */.Z)(currency, previous_period.total_revenues.value);
        var percentEarning = 0;
        if (previous_period.total_revenues.value !== 0) {
            percentEarning = Math.round((current_period.total_revenues.value - previous_period.total_revenues.value) / previous_period.total_revenues.value * 100);
        }
        return {
            id: id,
            isbn: isbn,
            title: title,
            totalCurrentRevenues: totalCurrentRevenues,
            totalPreviousRevenues: totalPreviousRevenues,
            percentEarning: percentEarning,
            cover: (0,change_cover_url/* default */.Z)(cover_link)
        };
    });
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
        isWaiting: isWaiting
    });
});
/* harmony default export */ var top_selling = (selectTopSelling);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/theme/link/index.js



function link_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 38px;\n  min-width: 140px;\n  color: ",
        ";\n  padding: 0 ",
        "px;\n  border-radius: 8px;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:focus {\n    color: ",
        ";\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    link_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledA = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-6c012d24-0"
})(link_templateObject(), (0,index_esm/* themeGet */.R)("colors.primary_400"), (0,index_esm/* themeGet */.R)("space.s"), (0,index_esm/* themeGet */.R)("colors.primary_500"), (0,index_esm/* themeGet */.R)("colors.primary_600"), dist_index_esm/* layout */.bK, dist_index_esm/* space */.Dh, dist_index_esm/* typography */.cp);
function CustomLink(param) {
    var title = param.title, children = param.children, type = param.type, href = param.href, disabled = param.disabled, style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        title: title,
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledA, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            fontSize: "h4",
            lineHeight: "h4",
            fontWeight: "bold",
            type: type,
            disabled: disabled
        }, style), {
            children: children
        }))
    });
}
/* harmony default export */ var theme_link = (CustomLink);

;// CONCATENATED MODULE: ./src/theme/top-selling-card/index.js
/* eslint-disable no-nested-ternary */ 
function top_selling_card_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  cursor: pointer;\n\n  display: flex;\n  flex-direction: row;\n  border-bottom: 2px solid ",
        ";\n  text-decoration: none;\n\n  & > img {\n    width: 40px;\n    min-width: 40px;\n    height: 66px;\n  }\n"
    ]);
    top_selling_card_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function top_selling_card_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding-left: ",
        "px;\n  text-decoration: none;\n\n  & > .cta {\n    color: ",
        ";\n\n    & > :hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    top_selling_card_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function top_selling_card_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  user-select: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* stylelint-disable */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  /* stylelint-enable */\n  -webkit-line-clamp: 2;\n"
    ]);
    top_selling_card_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function top_selling_card_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n"
    ]);
    top_selling_card_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var top_selling_card_Wrapper = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-1754e8e2-0"
})(top_selling_card_templateObject(), dist_index_esm/* space */.Dh, (0,index_esm/* themeGet */.R)("colors.primary_50"));
var top_selling_card_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1754e8e2-1"
})(top_selling_card_templateObject1(), (0,index_esm/* themeGet */.R)("space.xs"), (0,index_esm/* themeGet */.R)("colors.primary_400"), (0,index_esm/* themeGet */.R)("colors.primary_300"));
var top_selling_card_Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1754e8e2-2"
})(top_selling_card_templateObject2(), dist_index_esm/* typography */.cp, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh, dist_index_esm/* layout */.bK);
var top_selling_card_Cover = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1754e8e2-3"
})(top_selling_card_templateObject3());
var Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1754e8e2-4"
})(_templateObject4(), dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh);
var ContentRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1754e8e2-5"
})(_templateObject5());
function TopSellingCard(param) {
    var payload = param.payload, error = param.error, onClick = param.onClick;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var handleClick = (0,react.useCallback)(function() {
        onClick(payload.isbn);
    }, [
        onClick,
        payload
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(top_selling_card_Wrapper, {
        title: payload.title,
        onClick: handleClick,
        p: "xs",
        mb: "xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(top_selling_card_Cover, {
                src: error ? "/images/book-error.jpg" : payload.cover || "/images/book.jpg",
                alt: "copertina"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(top_selling_card_Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(top_selling_card_Text, {
                        fontSize: [
                            "pSmall",
                            "pSmall",
                            "pSmall",
                            "h3"
                        ],
                        lineHeight: [
                            "pSmall",
                            "pSmall",
                            "pSmall",
                            "h3"
                        ],
                        fontWeight: "bold",
                        color: "grey_600",
                        children: !error ? payload.title : "error"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(top_selling_card_Text, {
                        fontSize: [
                            "pSmall",
                            "pSmall",
                            "pSmall",
                            "h3"
                        ],
                        lineHeight: [
                            "pSmall",
                            "pSmall",
                            "pSmall",
                            "h3"
                        ],
                        fontWeight: "normal",
                        color: "grey_600",
                        mt: "xs",
                        children: translations/* default */.Z[languageCode].Revenues
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(top_selling_card_Text, {
                                fontSize: "display",
                                lineHeight: "display",
                                fontWeight: "normal",
                                color: "grey_400",
                                textAlign: "left",
                                children: payload.totalCurrentRevenues
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                ml: "xxs",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_selling_card_Text, {
                                    fontSize: "label",
                                    lineHeight: "label",
                                    fontWeight: "bold",
                                    color: payload.growthRates === 0 ? "grey_600" : payload.growthRates < 0 ? "red_400" : "lime_400",
                                    textAlign: "right",
                                    children: "".concat(payload.percentEarning === 0 ? "" : payload.percentEarning < 0 ? "-" : "+", " ").concat(Math.abs(payload.percentEarning), "%")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var top_selling_card = (TopSellingCard);

;// CONCATENATED MODULE: ./src/components/top-selling/index.js
/* eslint-disable no-nested-ternary */ 
function top_selling_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    top_selling_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

















var top_selling_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1d452eb7-0"
})(top_selling_templateObject());
function TopSelling() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var push = (0,router.useRouter)().push;
    var ref = (0,react.useState)(null), queriedKey = ref[0], setQueriedKey = ref[1];
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }), formatDate = ref1.formatDate, currency = ref1.currency;
    var topSelling = (0,es/* useSelector */.v9)(function(state) {
        return top_selling(state, queriedKey);
    });
    var error = (0,es/* useSelector */.v9)(function(state) {
        return state.aggr;
    }).error;
    var ref2 = (0,es/* useSelector */.v9)(profile/* default */.Z), isAdmin = ref2.isAdmin, analytics_type = ref2.payload.analytics_type;
    var dateTo = (0,react.useMemo)(function() {
        var today = moment_default()();
        return today.format(formatDate);
    }, [
        formatDate
    ]);
    var dateFrom = (0,react.useMemo)(function() {
        var today = moment_default()();
        return today.subtract(30, "days").format(formatDate);
    }, [
        formatDate
    ]);
    var query = (0,react.useMemo)(function() {
        return(// return `currency=${currency}&term=title&size=3&dateTo=2021-05-01&dateFrom=2021-01-01&include=cover_link,title,isbn&dataType=real_data`;
        "currency=".concat(currency, "&term=title&size=3&dateTo=").concat(dateTo, "&dateFrom=").concat(dateFrom, "&include=cover_link,title,isbn&version=7&enterprise=").concat(analytics_type || "standard", "&isAdmin=").concat(isAdmin));
    }, [
        dateTo,
        dateFrom,
        currency,
        analytics_type,
        isAdmin
    ]);
    (0,react.useEffect)(function() {
        if (!query) return;
        var key = base64_default().encode(query);
        setQueriedKey(key);
        dispatch((0,aggr/* getAggrRequest */.js)({
            term: "title",
            key: key,
            query: query,
            currency: currency,
            isAdmin: isAdmin
        }));
    }, [
        dispatch,
        dateTo,
        dateFrom,
        query,
        currency,
        isAdmin
    ]);
    var handleClickCard = (0,react.useCallback)(function(isbn) {
        if (isbn) {
            dispatch((0,filters/* resetFilters */.aw)());
            var parsedQuery = isbn ? {
                filters: "isbn=".concat(isbn)
            } : null;
            push({
                pathname: "/analytics",
                query: parsedQuery
            });
        }
    }, [
        dispatch,
        push
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(top_selling_Wrapper, {
        children: [
            topSelling.isWaiting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(cards, {}) : topSelling.payload.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(card_placeholder, {}) : topSelling.payload.map(function(el) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(top_selling_card, {
                    payload: el,
                    error: error,
                    onClick: handleClickCard
                }, el.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_link, {
                style: {
                    p: 0
                },
                href: "/analytics",
                title: translations/* default */.Z[languageCode]["go to analytics"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: [
                        "pSmall",
                        "pSmall",
                        "pSmall",
                        "pLarge"
                    ],
                    lineHeight: [
                        "pSmall",
                        "pSmall",
                        "pSmall",
                        "pLarge"
                    ],
                    fontWeight: "bold",
                    children: translations/* default */.Z[languageCode]["go to analytics"]
                })
            })
        ]
    });
}
/* harmony default export */ var components_top_selling = (TopSelling);

// EXTERNAL MODULE: ./src/theme/icons/plus.js
var plus = __webpack_require__(26398);
// EXTERNAL MODULE: ./src/theme/modal/index.js
var modal = __webpack_require__(75436);
// EXTERNAL MODULE: ./src/theme/icons/write.js
var write = __webpack_require__(54469);
;// CONCATENATED MODULE: ./src/theme/link/border.js



function border_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 38px;\n  min-width: 140px;\n  background: ",
        ";\n  color: ",
        ";\n  padding: 0 ",
        "px;\n  border: 1px solid;\n  border-radius: 8px;\n  cursor: pointer;\n  text-decoration: none;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  &:focus {\n    background: ",
        ";\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    border_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var border_StyledA = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-278054db-0"
})(border_templateObject(), (0,index_esm/* themeGet */.R)("colors.white"), (0,index_esm/* themeGet */.R)("colors.grey_600"), (0,index_esm/* themeGet */.R)("space.s"), (0,index_esm/* themeGet */.R)("colors.primary_50"), (0,index_esm/* themeGet */.R)("colors.primary_50"), dist_index_esm/* flexbox */.GQ, dist_index_esm/* layout */.bK, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh, dist_index_esm/* typography */.cp, dist_index_esm/* border */.Cg);
function border_CustomLink(param) {
    var title = param.title, children = param.children, type = param.type, href = param.href, disabled = param.disabled, style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(border_StyledA, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: href,
        title: title,
        fontSize: "h4",
        lineHeight: "h4",
        fontWeight: "bold",
        type: type,
        disabled: disabled
    }, style), {
        children: children
    }));
}
/* harmony default export */ var border = (border_CustomLink);

;// CONCATENATED MODULE: ./src/components/add-new-content/steps.js

function steps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        "\n\n  & > .divider {\n    width: 100%;\n    height: 1px;\n    background-color: ",
        ";\n  }\n"
    ]);
    steps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function steps_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        "\n\n  & > .row {\n    display: flex;\n    flex-direction: row;\n  }\n\n  & > .row > .circle-icon {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background: ",
        ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  & > .row > .content {\n    display: flex;\n    flex: 1;\n    padding: 0 ",
        "px;\n  }\n"
    ]);
    steps_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var steps_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f48bbce-0"
})(steps_templateObject(), dist_index_esm/* space */.Dh, (0,index_esm/* themeGet */.R)("colors.primary_100"));
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f48bbce-1"
})(steps_templateObject1(), dist_index_esm/* space */.Dh, function(param) {
    var bgColor = param.bgColor;
    return (0,index_esm/* themeGet */.R)("colors.".concat(bgColor));
}, (0,index_esm/* themeGet */.R)("space.m"));
function StepNewContent() {
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var payload = (0,es/* useSelector */.v9)(profile/* default */.Z).payload;
    var services = (0,es/* useSelector */.v9)(profile/* selectServices */.M).services;
    var hubService = services.find(function(service) {
        var ref;
        return (service === null || service === void 0 ? void 0 : (ref = service.platform) === null || ref === void 0 ? void 0 : ref.name) === "DISTRIBUTION";
    });
    var writeService = services.find(function(service) {
        var ref;
        return (service === null || service === void 0 ? void 0 : (ref = service.platform) === null || ref === void 0 ? void 0 : ref.name) === "WRITE";
    });
    var platformUrls = {};
    if (payload.abilities) platformUrls = get_platform_urls(payload.abilities);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(steps_Wrapper, {
        px: "m",
        mb: "m",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "divider"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                fontSize: "h2",
                lineHeight: "h2",
                fontWeight: "bold",
                color: "grey_600",
                my: "l",
                children: translations/* default */.Z[languageCode]["Is your file ready for distribution?"]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                bgColor: "distribute",
                pb: "m",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "circle-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_distribute, {
                                width: "30",
                                color: "white"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "normal",
                                color: "grey_400",
                                children: translations/* default */.Z[languageCode]["Go to StreetLib Hub and start publishing your ebooks, audiobooks, and print-on-demand books, with all the major online libraries!"]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(border, {
                            href: !hubService && (hubService === null || hubService === void 0 ? void 0 : hubService.isNotSignable) ? "/onboarding" : (hubService === null || hubService === void 0 ? void 0 : hubService.enabled) ? platformUrls.publish : "/enable-service?id=SHUFFLE_PUBLISH",
                            type: "button",
                            style: {
                                maxWidth: "220px",
                                height: "56px",
                                px: "s",
                                borderColor: "distribute",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "pLarge",
                                lineHeight: "pLarge",
                                fontWeight: "medium",
                                children: translations/* default */.Z[languageCode]["Upload Content"]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "divider"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                fontSize: "h2",
                lineHeight: "h2",
                fontWeight: "bold",
                color: "grey_600",
                my: "l",
                children: translations/* default */.Z[languageCode]["Do you need assistance with the files to be distributed?"]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                bgColor: "write",
                pb: "m",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "circle-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(write/* default */.Z, {
                                width: "30",
                                color: "white"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "normal",
                                color: "grey_400",
                                children: translations/* default */.Z[languageCode]["Go to streetLib Write and create your own print-ready ePubs and Mobi, PDFs files and covers. With a few, simple steps you can get your files ready for distribution!"]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(border, {
                            href: !writeService && (writeService === null || writeService === void 0 ? void 0 : writeService.enabled) ? platformUrls.write : "/enable-service?id=SHUFFLE_WRITE",
                            type: "button",
                            style: {
                                maxWidth: "220px",
                                height: "56px",
                                px: "s",
                                borderColor: "write",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "pLarge",
                                lineHeight: "pLarge",
                                fontWeight: "medium",
                                children: translations/* default */.Z[languageCode]["Create your own book"]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                bgColor: "print",
                py: "m",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "circle-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_print, {
                                width: "30",
                                color: "white"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "normal",
                                color: "grey_400",
                                children: translations/* default */.Z[languageCode]["You can rely on the StreetLib Ready Team for the production of your ebook and audiobook files, publication of your PDFs, and to access many other useful services!"]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(border, {
                            href: "https://readybooks.io",
                            type: "button",
                            style: {
                                maxWidth: "220px",
                                height: "56px",
                                px: "s",
                                borderColor: "print",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "pLarge",
                                lineHeight: "pLarge",
                                fontWeight: "medium",
                                children: translations/* default */.Z[languageCode]["Find out editorial services"]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var steps = (StepNewContent);

;// CONCATENATED MODULE: ./src/components/add-new-content/index.js

function add_new_content_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 140px;\n  background: transparent;\n  margin: 0;\n  padding: 0;\n\n  & > span {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    background: ",
        ";\n    color: ",
        ";\n    padding: 0 ",
        "px;\n    border-radius: 8px;\n\n    &:hover {\n      background: ",
        ";\n    }\n\n    &:focus {\n      background: ",
        ";\n    }\n\n    &:disabled {\n      opacity: 0.5;\n    }\n\n    ",
        "\n    ",
        "\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    add_new_content_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function add_new_content_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n"
    ]);
    add_new_content_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var add_new_content_Wrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-fe662e06-0"
})(add_new_content_templateObject(), (0,index_esm/* themeGet */.R)("colors.primary_400"), (0,index_esm/* themeGet */.R)("colors.white"), (0,index_esm/* themeGet */.R)("space.s"), (0,index_esm/* themeGet */.R)("colors.primary_300"), (0,index_esm/* themeGet */.R)("colors.primary_200"), dist_index_esm/* color */.$_, dist_index_esm/* typography */.cp, dist_index_esm/* space */.Dh, dist_index_esm/* layout */.bK);
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(theme_text/* default */.Z).withConfig({
    componentId: "sc-fe662e06-1"
})(add_new_content_templateObject1());
function AddNewContent() {
    var ref = (0,react.useState)(false), isVisible = ref[0], setVisible = ref[1];
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var ref1 = (0,es/* useSelector */.v9)(profile/* default */.Z), company = ref1.payload.company;
    var handleOpen = (0,react.useCallback)(function() {
        setVisible(true);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setVisible(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(add_new_content_Wrapper, {
                title: translations/* default */.Z[languageCode]["add new content"],
                href: "/",
                type: "button",
                onClick: handleOpen,
                width: "100%",
                height: [
                    "38px",
                    "38px",
                    "38px",
                    "48px"
                ],
                mb: "s",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(plus/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                            fontSize: [
                                "pLarge",
                                "pLarge",
                                "pLarge",
                                "h3"
                            ],
                            lineHeight: [
                                "pLarge",
                                "pLarge",
                                "pLarge",
                                "h3"
                            ],
                            fontWeight: "medium",
                            ml: "xs",
                            children: translations/* default */.Z[languageCode]["add new content"]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                width: "900px",
                bgColor: "white",
                contentStyle: {
                    py: 0
                },
                isVisible: isVisible,
                onClose: handleClose,
                title: translations/* default */.Z[languageCode]["create new content"],
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: translations/* default */.Z[languageCode]["Help center"],
                    href: "".concat((company === null || company === void 0 ? void 0 : company.code) === "SL_DE" ? "//help.bookrixe.de" : "//help.streetlib.com"),
                    className: "link",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        fontSize: "h4",
                        lineHeight: "h4",
                        fontWeight: "bold",
                        color: "grey_600",
                        children: translations/* default */.Z[languageCode]["Help center"]
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(steps, {})
            })
        ]
    });
}
/* harmony default export */ var add_new_content = (AddNewContent);

// EXTERNAL MODULE: ./src/theme/content-loader/index.js
var content_loader = __webpack_require__(52005);
// EXTERNAL MODULE: ./src/theme/tooltip/index.js
var tooltip = __webpack_require__(4509);
// EXTERNAL MODULE: ./src/theme/icons/info-circle.js
var info_circle = __webpack_require__(62878);
;// CONCATENATED MODULE: ./src/components/dashboard/service-cards/index.js
/* eslint-disable no-nested-ternary */ 
function service_cards_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    service_cards_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function service_cards_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n\n  & > .card-content {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    height: 100%;\n\n    & > .header {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      flex: 1;\n\n      & > div {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n      }\n    }\n\n    & > .bottom {\n      & > .divider {\n        width: 100%;\n        height: 1px;\n        background-color: ",
        ";\n      }\n\n      & > .footer {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        margin-top: ",
        "px;\n        flex-wrap: wrap;\n\n        & > div {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n        }\n\n        & > .footer-link {\n          flex: 1;\n        }\n      }\n    }\n  }\n"
    ]);
    service_cards_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function service_cards_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    service_cards_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function service_cards_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n  border-radius: 24px;\n  background-color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ::after {\n    content: '';\n    width: 16px;\n    height: 16px;\n    border-radius: 16px;\n    background-color: ",
        ";\n  }\n"
    ]);
    service_cards_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function service_cards_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  color: ",
        ";\n"
    ]);
    service_cards_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function service_cards_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n"
    ]);
    service_cards_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}















var service_cards_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-992f0ea-0"
})(service_cards_templateObject());
var ServiceCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-992f0ea-1"
})(service_cards_templateObject1(), (0,index_esm/* themeGet */.R)("colors.primary_100"), (0,index_esm/* themeGet */.R)("space.xs"));
var WrapStatusLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-992f0ea-2"
})(service_cards_templateObject2(), dist_index_esm/* layout */.bK);
var CircleStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-992f0ea-3"
})(service_cards_templateObject3(), function(param) {
    var isCompleted = param.isCompleted;
    return isCompleted ? (0,index_esm/* themeGet */.R)("colors.primary_100") : (0,index_esm/* themeGet */.R)("colors.grey_100");
}, function(param) {
    var isCompleted = param.isCompleted;
    return isCompleted ? (0,index_esm/* themeGet */.R)("colors.primary_400") : (0,index_esm/* themeGet */.R)("colors.grey_200");
});
var WrapInfoBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-992f0ea-4"
})(service_cards_templateObject4(), (0,index_esm/* themeGet */.R)("colors.grey_400"));
var service_cards_StyledText = (0,styled_components_browser_esm/* default */.ZP)(theme_text/* default */.Z).withConfig({
    componentId: "sc-992f0ea-5"
})(service_cards_templateObject5());
function ServiceCards() {
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var isGetWaiting = (0,es/* useSelector */.v9)(function(state) {
        return state.profile;
    }).isGetWaiting;
    var services = (0,es/* useSelector */.v9)(profile/* selectServices */.M).services;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(service_cards_Wrapper, {
        children: isGetWaiting && services.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
            width: 200,
            height: 230,
            lines: [
                {
                    x: 0,
                    y: 0,
                    rx: 5,
                    ry: 5,
                    width: 80,
                    height: 20
                },
                {
                    x: 0,
                    y: 30,
                    rx: 5,
                    ry: 5,
                    width: 200,
                    height: 90
                }, 
            ]
        }) : services.map(function(service) {
            return service.platform.label !== "StreetLib" && /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                width: "100%",
                bg: service.enabled && !service.isNotSignable ? "white" : "primary_50",
                borderColor: service.isNotSignable ? "primary_100" : service.enabled ? "primary_400" : "primary_200",
                borderWidth: service.isNotSignable ? "1px" : service.enabled ? "2px" : "1px",
                py: "xs",
                px: "s",
                my: "xs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceCard, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "card-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                        fontSize: "h3",
                                        lineHeight: "h3",
                                        fontWeight: "bold",
                                        color: service.isNotSignable ? "grey_400" : "grey_600",
                                        children: service.platform.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapStatusLabel, {
                                                display: [
                                                    "none",
                                                    "none",
                                                    "none",
                                                    "block"
                                                ],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                    fontSize: "pSmall",
                                                    lineHeight: "pSmall",
                                                    fontWeight: "medium",
                                                    color: "grey_600",
                                                    mr: "xs",
                                                    children: service.isNotSignable ? translations/* default */.Z[languageCode].disabled : service.enabled ? translations/* default */.Z[languageCode].Enabled : translations/* default */.Z[languageCode]["Not enabled"]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleStatus, {
                                                isCompleted: !service.isNotSignable && service.enabled
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bottom",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                        fontSize: "pLarge",
                                        lineHeight: "pLarge",
                                        fontWeight: "medium",
                                        mt: "xs",
                                        color: "grey_400",
                                        children: service.platform.description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "footer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-link",
                                            children: service.isNotSignable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapInfoBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                                        forData: "".concat(service.platform.label),
                                                        text: translations/* default */.Z[languageCode].not_signable
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        "data-tip": true,
                                                        "data-for": "".concat(service.platform.label),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* default */.Z, {})
                                                    })
                                                ]
                                            }) : service.enabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link/* default */.Z, {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                label: translations/* default */.Z[languageCode]["Go to the service"],
                                                href: service.platform.url
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_link, {
                                                style: {
                                                    p: 0
                                                },
                                                href: "/enable-service?id=".concat(service.platform.name),
                                                title: translations/* default */.Z[languageCode].Request,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(service_cards_StyledText, {
                                                    fontSize: "pLarge",
                                                    lineHeight: "pLarge",
                                                    fontWeight: "bold",
                                                    color: "primary_400",
                                                    children: translations/* default */.Z[languageCode].Request
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }, service.platform.label);
        })
    });
}
/* harmony default export */ var service_cards = (ServiceCards);

// EXTERNAL MODULE: ./src/redux/reselect/teams.js
var teams = __webpack_require__(81061);
;// CONCATENATED MODULE: ./src/components/scope-gate/index.js


// Renders children only when the team member has access to the given section.
// Otherwise renders `fallback` (children are not mounted, so no API calls fire).
function ScopeGate(param) {
    var section = param.section, children = param.children, _fallback = param.fallback, fallback = _fallback === void 0 ? null : _fallback;
    var canAccessSection = (0,es/* useSelector */.v9)(teams/* default */.ZP).canAccessSection;
    return canAccessSection(section) ? children : fallback;
}
/* harmony default export */ var scope_gate = (ScopeGate);

// EXTERNAL MODULE: ./src/theme/icons/lock.js
var lock = __webpack_require__(41396);
;// CONCATENATED MODULE: ./src/theme/locked-section/index.js



function locked_section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    locked_section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var Inner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a68f5dfd-0"
})(locked_section_templateObject(), dist_index_esm/* space */.Dh, dist_index_esm/* layout */.bK, (0,index_esm/* themeGet */.R)("colors.grey_200"));
function LockedSection(param) {
    var width = param.width, _minHeight = param.minHeight, minHeight = _minHeight === void 0 ? "120px" : _minHeight, message = param.message, style = param.style;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: width || "100%",
        bg: "grey_100",
        borderColor: "primary_200",
        py: "m",
        px: "s"
    }, style), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            minHeight: minHeight,
            px: "s",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lock/* default */.Z, {
                    width: "28"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: [
                        "pSmall",
                        "pSmall",
                        "pSmall",
                        "pLarge"
                    ],
                    lineHeight: [
                        "pSmall",
                        "pSmall",
                        "pSmall",
                        "pLarge"
                    ],
                    fontWeight: "medium",
                    color: "grey_400",
                    mt: "xs",
                    children: message || translations/* default */.Z[languageCode]["insufficient permissions"]
                })
            ]
        })
    }));
}
/* harmony default export */ var locked_section = (LockedSection);

;// CONCATENATED MODULE: ./src/theme/sidebar/index.js

function sidebar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n\n  /* Stacked under the content on a phone, so it takes the width it is given;\n     beside it from the first breakpoint up, where 236px is what it needs. */\n  @media (min-width: ",
        ") {\n    min-width: 236px;\n  }\n"
    ]);
    sidebar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var sidebar_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c2e1e4b-0"
})(sidebar_templateObject(), dist_index_esm/* space */.Dh, dist_index_esm/* color */.$_, dist_index_esm/* layout */.bK, (0,index_esm/* themeGet */.R)("breakpoints.0"));
function Sidebar() {
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sidebar_Wrapper, {
        width: [
            "100%",
            "236px",
            "236px",
            "320px"
        ],
        /* Stacked under the content it is the page, so it needs both margins;
         beside the content only the right one, as before. */ pl: [
            "s",
            0,
            0,
            0
        ],
        pr: "s",
        mt: [
            "m",
            0,
            0,
            0
        ],
        bg: "white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(add_new_content, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(service_cards, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                fontSize: [
                    "h3",
                    "h3",
                    "h3",
                    "h2"
                ],
                lineHeight: [
                    "h3",
                    "h3",
                    "h3",
                    "h2"
                ],
                fontWeight: "bold",
                mt: "m",
                mb: "xs",
                color: "grey_600",
                children: translations/* default */.Z[languageCode]["publishing history"]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(scope_gate, {
                section: "catalog",
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(locked_section, {
                    width: "100%",
                    minHeight: "120px"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(publishing_history, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                fontSize: [
                    "h3",
                    "h3",
                    "h3",
                    "h2"
                ],
                lineHeight: [
                    "h3",
                    "h3",
                    "h3",
                    "h2"
                ],
                fontWeight: "bold",
                mt: "m",
                mb: "xs",
                color: "grey_600",
                children: translations/* default */.Z[languageCode]["top selling titles"]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                fontSize: [
                    "h6",
                    "h6",
                    "h6",
                    "h5"
                ],
                lineHeight: [
                    "h6",
                    "h6",
                    "h6",
                    "h6"
                ],
                fontWeight: "bold",
                mb: "xs",
                color: "grey_200",
                children: translations/* default */.Z[languageCode]["last 30 days"]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(scope_gate, {
                section: "analytics",
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(locked_section, {
                    width: "100%",
                    minHeight: "120px"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_top_selling, {})
            })
        ]
    });
}
/* harmony default export */ var sidebar = (Sidebar);

// EXTERNAL MODULE: ./src/theme/header/index.js + 1 modules
var header = __webpack_require__(28116);
// EXTERNAL MODULE: ./src/components/auth-switch/index.js + 15 modules
var auth_switch = __webpack_require__(17343);
// EXTERNAL MODULE: ./src/redux/action/count.js
var count = __webpack_require__(85231);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(54490);
// EXTERNAL MODULE: ./src/redux/reselect/units.js
var units = __webpack_require__(10574);
// EXTERNAL MODULE: ./src/redux/reselect/revenue.js
var revenue = __webpack_require__(86704);
;// CONCATENATED MODULE: ./src/theme/icons/book.js



function book_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n\n  ",
        "\n  ",
        "\n"
    ]);
    book_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var book_Wrapper = (0,styled_components_browser_esm/* default */.ZP)("svg").withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "width"
        ].includes(prop);
    }
}).withConfig({
    componentId: "sc-da6cd1da-0"
})(book_templateObject(), dist_index_esm/* layout */.bK, dist_index_esm/* space */.Dh);
function Book(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(book_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.3 0.490234H3.60002C2.51462 0.490234 0.900024 1.20933 0.900024 3.19023V15.7902C0.900024 17.7711 2.51462 18.4902 3.60002 18.4902H17.1V16.6902H3.61082C3.19502 16.6794 2.70002 16.5156 2.70002 15.7902C2.70002 15.0648 3.19502 14.901 3.61082 14.8902H17.1V2.29023C17.1 1.29753 16.2927 0.490234 15.3 0.490234ZM15.3 13.0902H2.70002V3.19023C2.70002 2.46483 3.19502 2.30103 3.60002 2.29023H15.3V13.0902Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(0 0.490234)"
                    })
                })
            })
        ]
    }));
}
/* harmony default export */ var book = (Book);

;// CONCATENATED MODULE: ./src/components/counter-cards/temporary-units.js
/* eslint-disable no-nested-ternary */ 
function temporary_units_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  & > .card-percent {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: ",
        "px;\n\n    & > svg {\n      ",
        "\n    }\n  }\n"
    ]);
    temporary_units_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function temporary_units_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    temporary_units_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var temporary_units_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-72101ec8-0"
})(temporary_units_templateObject(), (0,index_esm/* themeGet */.R)("space.s"), dist_index_esm/* color */.$_);
var temporary_units_Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-72101ec8-1"
})(temporary_units_templateObject1(), dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh);
function TemporaryUnits(param) {
    var queriedKey = param.queriedKey;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var totals = (0,es/* useSelector */.v9)(function(state) {
        return (0,units/* selectTotalUnits */.k7)(state, queriedKey);
    });
    var temporaryUnits = (0,es/* useSelector */.v9)(function(state) {
        return (0,revenue/* default */.Z)(state, queriedKey);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        width: [
            "100%",
            "33.33%",
            "33.33%",
            "33.33%"
        ],
        bg: "grey_100",
        borderColor: "grey_200",
        pt: "l",
        pb: "l",
        ml: [
            0,
            "s",
            "s",
            "s"
        ],
        mt: [
            "s",
            0,
            0,
            0
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(temporary_units_Content, {
            color: "grey_200",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card-percent",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(book, {
                            style: {
                                width: [
                                    "24px",
                                    "24px",
                                    "24px",
                                    "45.5px"
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(temporary_units_Value, {
                            pl: "s",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: [
                                    "h2",
                                    "h2",
                                    "h2",
                                    "h2Large"
                                ],
                                lineHeight: [
                                    "h2",
                                    "h2",
                                    "h2",
                                    "h2Large"
                                ],
                                fontWeight: "bold",
                                color: temporaryUnits.percent > 0 ? "lime_400" : temporaryUnits.percent < 0 ? "red_400" : "grey_600",
                                children: "".concat(temporaryUnits.percent > 0 ? "+" : temporaryUnits.percent < 0 ? "-" : "", " ").concat(Math.abs(temporaryUnits.percent), "%")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: [
                        "display",
                        "display",
                        "display",
                        "h2"
                    ],
                    lineHeight: [
                        "display",
                        "display",
                        "display",
                        "h2"
                    ],
                    fontWeight: "bold",
                    color: "grey_600",
                    textAlign: "center",
                    mb: "xxs",
                    children: translations/* default */.Z[languageCode]["temporary units"]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: [
                        "h2",
                        "h2",
                        "h2",
                        "h3Large"
                    ],
                    lineHeight: [
                        "h2",
                        "h2",
                        "h2",
                        "h3Large"
                    ],
                    fontWeight: [
                        "medium",
                        "medium",
                        "medium",
                        "normal"
                    ],
                    color: "grey_600",
                    textAlign: "center",
                    children: totals.quantity === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                        width: 50,
                        height: 16,
                        lines: [
                            {
                                x: 0,
                                y: 5,
                                rx: 5,
                                ry: 5,
                                width: 50,
                                height: 12
                            }, 
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* FormattedNumber */.BK, {
                        value: totals.quantity
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var temporary_units = (TemporaryUnits);

;// CONCATENATED MODULE: ./src/theme/icons/chart.js



function chart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 19px;\n\n  ",
        "\n  ",
        "\n"
    ]);
    chart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var chart_Wrapper = (0,styled_components_browser_esm/* default */.ZP)("svg").withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "width"
        ].includes(prop);
    }
}).withConfig({
    componentId: "sc-25614031-0"
})(chart_templateObject(), dist_index_esm/* layout */.bK, dist_index_esm/* space */.Dh);
function Chart(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chart_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
        viewBox: "0 0 19 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.8303 3.49023H12.8303V14.4902H10.8303V3.49023ZM14.8303 0.490234H16.8303V14.4902H14.8303V0.490234ZM6.83026 6.49023H8.83026V14.4902H6.83026V6.49023ZM1.83026 16.4902H17.8303V18.4902H1.83026V16.4902ZM2.83026 9.49023H4.83026V14.4902H2.83026V9.49023Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(0.830261 0.490234)"
                    })
                })
            })
        ]
    }));
}
/* harmony default export */ var chart = (Chart);

;// CONCATENATED MODULE: ./src/components/counter-cards/temporary-revenue.js
/* eslint-disable no-nested-ternary */ 
function temporary_revenue_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  & > .card-percent {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: ",
        "px;\n\n    & > svg {\n      ",
        "\n    }\n  }\n"
    ]);
    temporary_revenue_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function temporary_revenue_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    temporary_revenue_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var temporary_revenue_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e181169-0"
})(temporary_revenue_templateObject(), (0,index_esm/* themeGet */.R)("space.s"), dist_index_esm/* color */.$_);
var temporary_revenue_Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e181169-1"
})(temporary_revenue_templateObject1(), dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh);
function TemporaryRevenue(param) {
    var queriedKey = param.queriedKey;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var temporaryRevenue = (0,es/* useSelector */.v9)(function(state) {
        return (0,revenue/* default */.Z)(state, queriedKey);
    });
    var ref = (0,es/* useSelector */.v9)(profile/* default */.Z), company = ref.payload.company;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        width: [
            "100%",
            "33.33%",
            "33.33%",
            "33.33%"
        ],
        bg: "grey_100",
        borderColor: "primary_400",
        pt: "l",
        pb: "l",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(temporary_revenue_Content, {
            color: "primary_400",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card-percent",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chart, {
                            style: {
                                width: [
                                    "24px",
                                    "24px",
                                    "24px",
                                    "48px"
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(temporary_revenue_Value, {
                            pl: "s",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: [
                                    "h2",
                                    "h2",
                                    "h2",
                                    "h2Large"
                                ],
                                lineHeight: [
                                    "h2",
                                    "h2",
                                    "h2",
                                    "h2Large"
                                ],
                                fontWeight: "bold",
                                color: temporaryRevenue.percent > 0 ? "lime_400" : temporaryRevenue.percent < 0 ? "red_400" : "grey_600",
                                children: "".concat(temporaryRevenue.percent > 0 ? "+" : temporaryRevenue.percent < 0 ? "-" : "", " ").concat(Math.abs(temporaryRevenue.percent), "%")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: [
                        "display",
                        "display",
                        "display",
                        "h2"
                    ],
                    lineHeight: [
                        "display",
                        "display",
                        "display",
                        "h2"
                    ],
                    fontWeight: "bold",
                    color: "grey_600",
                    textAlign: "center",
                    mb: "xxs",
                    children: translations/* default */.Z[languageCode]["temporary revenues"]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: [
                        "h2",
                        "h2",
                        "h2",
                        "h3Large"
                    ],
                    lineHeight: [
                        "h2",
                        "h2",
                        "h2",
                        "h3Large"
                    ],
                    fontWeight: [
                        "medium",
                        "medium",
                        "medium",
                        "normal"
                    ],
                    color: "grey_600",
                    textAlign: "center",
                    children: temporaryRevenue.value === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                        width: 50,
                        height: 16,
                        lines: [
                            {
                                x: 0,
                                y: 5,
                                rx: 5,
                                ry: 5,
                                width: 50,
                                height: 12
                            }, 
                        ]
                    }) : temporaryRevenue.value
                }),
                company && company.code === "SL_US" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://www.streetlib.com/pricing/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        fontSize: [
                            "small"
                        ],
                        lineHeight: [
                            "h2"
                        ],
                        fontWeight: "bold",
                        color: "primary_300",
                        textAlign: "center",
                        mb: "xxs",
                        children: translations/* default */.Z[languageCode].earn_more_revenues
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var temporary_revenue = (TemporaryRevenue);

// EXTERNAL MODULE: ./src/redux/action/billing.js
var billing = __webpack_require__(52947);
// EXTERNAL MODULE: ./src/redux/reselect/billing.js
var reselect_billing = __webpack_require__(3411);
// EXTERNAL MODULE: ./src/redux/reselect/auth.js
var auth = __webpack_require__(23741);
// EXTERNAL MODULE: ./src/theme/icons/card.js
var icons_card = __webpack_require__(56704);
;// CONCATENATED MODULE: ./src/components/counter-cards/last-invoice.js
/* eslint-disable no-nested-ternary */ 
function last_invoice_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  & > .card-percent {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: ",
        "px;\n\n    & > svg {\n      ",
        "\n    }\n  }\n"
    ]);
    last_invoice_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function last_invoice_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    last_invoice_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var last_invoice_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a4fcdd98-0"
})(last_invoice_templateObject(), (0,index_esm/* themeGet */.R)("space.s"), dist_index_esm/* color */.$_);
var last_invoice_Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a4fcdd98-1"
})(last_invoice_templateObject1(), dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh);
function LastInvoice() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var adminRequestedStreetlibInternalId = (0,es/* useSelector */.v9)(auth/* default */.Z).adminRequestedStreetlibInternalId;
    var payload = (0,es/* useSelector */.v9)(reselect_billing/* default */.ZP);
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    (0,react.useEffect)(function() {
        dispatch((0,billing/* getBillingSummaryRequest */.AK)());
    }, [
        dispatch,
        adminRequestedStreetlibInternalId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        width: [
            "100%",
            "33.33%",
            "33.33%",
            "33.33%"
        ],
        bg: "grey_100",
        borderColor: "pie_1_3",
        pt: "l",
        pb: "l",
        ml: [
            0,
            "s",
            "s",
            "s"
        ],
        mt: [
            "s",
            0,
            0,
            0
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(last_invoice_Content, {
            color: "pie_1_3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card-percent",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_card/* default */.Z, {
                            style: {
                                width: [
                                    "24px",
                                    "24px",
                                    "24px",
                                    "48px"
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(last_invoice_Value, {
                            pl: "s",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: [
                                    "h2",
                                    "h2",
                                    "h2",
                                    "h2Large"
                                ],
                                lineHeight: [
                                    "h2",
                                    "h2",
                                    "h2",
                                    "h2Large"
                                ],
                                fontWeight: "bold",
                                color: payload.earningsPercentage > 0 ? "lime_400" : payload.earningsPercentage < 0 ? "red_400" : "grey_600",
                                children: "".concat(payload.earningsPercentage > 0 ? "+" : payload.earningsPercentage < 0 ? "-" : "", " ").concat(Math.abs(payload.earningsPercentage), "%")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: [
                        "display",
                        "display",
                        "display",
                        "h2"
                    ],
                    lineHeight: [
                        "display",
                        "display",
                        "display",
                        "h2"
                    ],
                    fontWeight: "bold",
                    color: "grey_600",
                    textAlign: "center",
                    mb: "xxs",
                    children: translations/* default */.Z[languageCode]["last billed invoice"]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: [
                        "h2",
                        "h2",
                        "h2",
                        "h3Large"
                    ],
                    lineHeight: [
                        "h2",
                        "h2",
                        "h2",
                        "h3Large"
                    ],
                    fontWeight: [
                        "medium",
                        "medium",
                        "medium",
                        "normal"
                    ],
                    color: "grey_600",
                    textAlign: "center",
                    children: payload.lastEarned === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                        width: 50,
                        height: 16,
                        lines: [
                            {
                                x: 0,
                                y: 5,
                                rx: 5,
                                ry: 5,
                                width: 50,
                                height: 12
                            }, 
                        ]
                    }) : payload.lastEarned
                })
            ]
        })
    });
}
/* harmony default export */ var last_invoice = (LastInvoice);

;// CONCATENATED MODULE: ./src/components/counter-cards/index.js











function CounterCards() {
    var ref = (0,react.useState)(null), queriedKey = ref[0], setQueriedKey = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }), formatDate = ref1.formatDate, currency = ref1.currency;
    var analytics_type = (0,es/* useSelector */.v9)(function(state) {
        return state.profile.payload;
    }).analytics_type;
    var ref2 = (0,es/* useSelector */.v9)(teams/* default */.ZP), canAccessAnalytics = ref2.canAccessAnalytics, canAccessBilling = ref2.canAccessBilling;
    var dateTo = (0,react.useMemo)(function() {
        var today = moment_default()();
        return today.format(formatDate);
    }, [
        formatDate
    ]);
    var dateFrom = (0,react.useMemo)(function() {
        var today = moment_default()();
        return today.subtract(30, "days").format(formatDate);
    }, [
        formatDate
    ]);
    var query = (0,react.useMemo)(function() {
        if (!dateTo || !dateFrom) return null;
        return "currency=".concat(currency, "&dataType=temporary_data&dateFrom=").concat(dateFrom, "&dateTo=").concat(dateTo, "&version=7&enterprise=").concat(analytics_type || "standard");
    }, [
        dateTo,
        dateFrom,
        currency,
        analytics_type
    ]);
    (0,react.useEffect)(function() {
        if (!query || !canAccessAnalytics) return;
        var key = base64_default().encode(query);
        setQueriedKey(key);
        dispatch((0,count/* getCountRequest */.YM)({
            key: key,
            query: query,
            currency: currency
        }));
    }, [
        dispatch,
        query,
        currency,
        canAccessAnalytics
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            canAccessAnalytics ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(temporary_revenue, {
                        queriedKey: queriedKey
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(temporary_units, {
                        queriedKey: queriedKey
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(locked_section, {
                        width: "33.33%",
                        minHeight: "140px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(locked_section, {
                        width: "33.33%",
                        minHeight: "140px",
                        style: {
                            ml: "s"
                        }
                    })
                ]
            }),
            canAccessBilling ? /*#__PURE__*/ (0,jsx_runtime.jsx)(last_invoice, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(locked_section, {
                width: "33.33%",
                minHeight: "140px",
                style: {
                    ml: "s"
                }
            })
        ]
    });
}
/* harmony default export */ var counter_cards = (CounterCards);

// EXTERNAL MODULE: ./src/redux/action/news.js
var action_news = __webpack_require__(1061);
// EXTERNAL MODULE: ./src/redux/reselect/config.js
var config = __webpack_require__(57708);
;// CONCATENATED MODULE: ./src/redux/reselect/news.js
/* eslint-disable camelcase */ 


var selectMedium = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.news.payload;
}, config/* default */.ZP, function(payload, param) {
    var languageCode = param.languageCode;
    var posts = payload.posts;
    if (!posts) return [];
    try {
        return posts.map(function(post) {
            var id = post.id, title = post.title, published_at = post.published_at, excerpt = post.excerpt, tags = post.tags, url = post.url;
            moment_default().locale(languageCode);
            var publishedAt = moment_default()(published_at, "YYYY-MM-DD hh:mm:ss").format("DD MMMM YYYY");
            return {
                id: id,
                title: title,
                tags: tags.filter(function(tag) {
                    return tag.visibility === "public";
                }).slice(0, 3),
                subtitle: excerpt,
                publishedAt: publishedAt,
                link: url
            };
        });
    } catch (e) {
        return [];
    }
});
/* harmony default export */ var reselect_news = (selectMedium);

;// CONCATENATED MODULE: ./src/components/news-cards/tags.js

function tags_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n\n  & > div:last-child {\n    margin-right: 0;\n  }\n"
    ]);
    tags_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function tags_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  width: fit-content;\n  border-radius: 4px;\n  text-decoration: none;\n"
    ]);
    tags_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var tags_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4b863d53-0"
})(tags_templateObject(), dist_index_esm/* space */.Dh);
var Tag = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-4b863d53-1"
})(tags_templateObject1(), dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh);
function Tags(param) {
    var payload = param.payload;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tags_Wrapper, {
        mt: "m",
        children: payload.map(function(tag) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                title: tag,
                href: tag.url,
                target: "_blank",
                rel: "noreferrer",
                bg: "primary_100",
                px: "xs",
                py: "xxxs",
                mr: "xs",
                mb: "xs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: [
                        "pSmall",
                        "pSmall",
                        "pSmall",
                        "pLarge"
                    ],
                    lineHeight: [
                        "pSmall",
                        "pSmall",
                        "pSmall",
                        "pLarge"
                    ],
                    fontWeight: "normal",
                    color: "grey_600",
                    children: tag.name
                })
            }, tag.id);
        })
    });
}
/* harmony default export */ var tags = (Tags);

;// CONCATENATED MODULE: ./src/components/news-cards/index.js

function news_cards_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  .title {\n    padding: 0 0 ",
        "px ",
        "px;\n  }\n\n  /* Three cards in a row leave a phone with three columns of clipped words.\n     Stacked below the first breakpoint, side by side above it. */\n  .cards {\n    display: flex;\n    flex-direction: column;\n\n    & > div {\n      padding: 0 ",
        "px ",
        "px;\n      width: 100%;\n    }\n  }\n\n  @media (min-width: ",
        ") {\n    .cards {\n      flex-direction: row;\n\n      & > div {\n        padding: 0 ",
        "px;\n        width: 33%;\n      }\n    }\n  }\n"
    ]);
    news_cards_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function news_cards_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  height: ",
        "px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* stylelint-disable */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  /* stylelint-enable */\n  -webkit-line-clamp: ",
        ";\n\n  @media screen and (min-width: 1440px) {\n    height: ",
        "px;\n  }\n"
    ]);
    news_cards_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function news_cards_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  width: 0;\n  min-width: 100%;\n  height: ",
        "px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* stylelint-disable */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  /* stylelint-enable */\n  -webkit-line-clamp: ",
        ";\n"
    ]);
    news_cards_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function news_cards_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n"
    ]);
    news_cards_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var news_cards_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-24d0edbd-0"
})(news_cards_templateObject(), (0,index_esm/* themeGet */.R)("space.m"), (0,index_esm/* themeGet */.R)("space.xs"), (0,index_esm/* themeGet */.R)("space.xs"), (0,index_esm/* themeGet */.R)("space.s"), (0,index_esm/* themeGet */.R)("breakpoints.0"), (0,index_esm/* themeGet */.R)("space.xs"));
var TextEllipsis = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-24d0edbd-1"
})(news_cards_templateObject1(), dist_index_esm/* typography */.cp, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh, function(param) {
    var line = param.line;
    return line * 22;
}, function(param) {
    var line = param.line;
    return line;
}, function(param) {
    var line = param.line;
    return line * 30;
});
var TextSubTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-24d0edbd-2"
})(news_cards_templateObject2(), dist_index_esm/* typography */.cp, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh, function(param) {
    var line = param.line;
    return line * 22;
}, function(param) {
    var line = param.line;
    return line;
});
var Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-24d0edbd-3"
})(news_cards_templateObject3());
function NewsCards() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var news = (0,es/* useSelector */.v9)(reselect_news);
    (0,react.useEffect)(function() {
        dispatch((0,action_news/* getNewsRequest */.Cc)());
    }, [
        dispatch,
        languageCode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(news_cards_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    fontSize: [
                        "h3",
                        "h3",
                        "h3",
                        "h2"
                    ],
                    lineHeight: [
                        "h3",
                        "h3",
                        "h3",
                        "h2"
                    ],
                    fontWeight: "bold",
                    color: "grey_600",
                    textAlign: "left",
                    children: translations/* default */.Z[languageCode]["latest news"]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cards",
                children: news.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
                            width: "100%",
                            minHeight: "100%",
                            bg: index === 0 ? "primary_50" : "white",
                            borderColor: index === 0 ? "primary_400" : "primary_100",
                            borderWidth: index === 0 ? "2px" : "1px",
                            py: "m",
                            px: "s",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                                    title: item.title,
                                    href: item.link,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                            fontSize: [
                                                "pSmall",
                                                "pSmall",
                                                "pSmall",
                                                "pLarge"
                                            ],
                                            lineHeight: [
                                                "pSmall",
                                                "pSmall",
                                                "pSmall",
                                                "pLarge"
                                            ],
                                            fontWeight: "normal",
                                            color: "grey_400",
                                            mb: "xs",
                                            children: item.publishedAt
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEllipsis, {
                                            fontSize: [
                                                "pLarge",
                                                "pLarge",
                                                "pLarge",
                                                "h2"
                                            ],
                                            lineHeight: [
                                                "pLarge",
                                                "pLarge",
                                                "pLarge",
                                                "h2"
                                            ],
                                            fontWeight: "bold",
                                            color: "grey_600",
                                            mb: "xs",
                                            line: "2",
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSubTitle, {
                                            fontSize: [
                                                "pLarge",
                                                "pLarge",
                                                "pLarge",
                                                "h3"
                                            ],
                                            lineHeight: [
                                                "pLarge",
                                                "pLarge",
                                                "pLarge",
                                                "h3"
                                            ],
                                            fontWeight: "normal",
                                            color: "grey_400",
                                            line: "3",
                                            dangerouslySetInnerHTML: {
                                                __html: item.subtitle
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tags, {
                                    payload: item.tags
                                })
                            ]
                        })
                    }, item.id);
                })
            })
        ]
    });
}
/* harmony default export */ var news_cards = (NewsCards);

// EXTERNAL MODULE: ./src/components/warning-notification/index.js + 1 modules
var warning_notification = __webpack_require__(42805);
// EXTERNAL MODULE: ./src/redux/reselect/top-assets.js
var top_assets = __webpack_require__(76969);
// EXTERNAL MODULE: ./src/theme/charts/pie/index.js + 2 modules
var pie = __webpack_require__(70797);
;// CONCATENATED MODULE: ./src/theme/assets-revenue/chart.js
/* eslint-disable no-nested-ternary */ /* eslint-disable camelcase */ 
function assets_revenue_chart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    assets_revenue_chart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function chart_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    chart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function chart_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  user-select: none;\n"
    ]);
    chart_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function chart_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    chart_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var assets_revenue_chart_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e075e1-0"
})(assets_revenue_chart_templateObject());
var LabelWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e075e1-1"
})(chart_templateObject1(), dist_index_esm/* space */.Dh);
var chart_Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4e075e1-2"
})(chart_templateObject2(), dist_index_esm/* typography */.cp, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh);
var chart_Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e075e1-3"
})(chart_templateObject3(), dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh);
function chart_Chart(param) {
    var id = param.id, selected = param.selected, withLabel = param.withLabel, maxWidth = param.maxWidth;
    var pieAssets = (0,es/* useSelector */.v9)(function(state) {
        return (0,top_assets/* default */.Z)(state, id);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(assets_revenue_chart_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pie/* default */.Z, {
                data: pieAssets.pieChartData,
                maxWidth: maxWidth || "125",
                selected: selected
            }),
            withLabel && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrap, {
                mt: "m",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chart_Text, {
                        fontSize: "h2",
                        lineHeight: "h2",
                        fontWeight: "bold",
                        color: "grey_600",
                        textAlign: "right",
                        mr: "s",
                        children: pieAssets.value === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                            width: 100,
                            height: 16,
                            lines: [
                                {
                                    x: 0,
                                    y: 0,
                                    rx: 5,
                                    ry: 5,
                                    width: 100,
                                    height: 12
                                }, 
                            ]
                        }) : pieAssets.value
                    }),
                    pieAssets.percent === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                        width: 50,
                        height: 16,
                        lines: [
                            {
                                x: 0,
                                y: 0,
                                rx: 5,
                                ry: 5,
                                width: 25,
                                height: 10
                            }, 
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chart_Value, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chart_Text, {
                            fontSize: "pSmall",
                            lineHeight: "pSmall",
                            fontWeight: "bold",
                            color: pieAssets.percent > 0 ? "lime_400" : pieAssets.percent < 0 ? "red_400" : "grey_600",
                            textAlign: "right",
                            children: "".concat(pieAssets.percent > 0 ? "+" : pieAssets.percent < 0 ? "-" : "", " ").concat(Math.abs(pieAssets.percent), "%")
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var assets_revenue_chart = (chart_Chart);

;// CONCATENATED MODULE: ./src/theme/assets-revenue/row.js
/* eslint-disable no-nested-ternary */ 
function row_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px 0;\n  border-bottom: 1px solid ",
        ";\n\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  & > .label {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  & > .value {\n    width: 100%;\n  }\n"
    ]);
    row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function row_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  align-items: center;\n\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: ",
        ";\n"
    ]);
    row_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function row_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    row_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var Box = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-fd600caa-0"
})(row_templateObject(), (0,index_esm/* themeGet */.R)("space.s"), (0,index_esm/* themeGet */.R)("colors.primary_100"));
var row_Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-fd600caa-1"
})(row_templateObject1(), dist_index_esm/* typography */.cp, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh, function(param) {
    var textTransform = param.textTransform;
    return textTransform || "none";
});
var row_Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fd600caa-2"
})(row_templateObject2());
function Row(param) {
    var _payload = param.payload, payload = _payload === void 0 ? {
        growthRates: 10
    } : _payload;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "label",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(row_Text, {
                        fontSize: [
                            "h4",
                            "h4",
                            "h4",
                            "h2"
                        ],
                        lineHeight: [
                            "h4",
                            "h4",
                            "h4",
                            "h2"
                        ],
                        fontWeight: "bold",
                        color: "grey_400",
                        textTransform: "capitalize",
                        children: payload.label
                    }),
                    payload.growthRates === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                        width: 50,
                        height: 16,
                        lines: [
                            {
                                x: 25,
                                y: 0,
                                rx: 5,
                                ry: 5,
                                width: 25,
                                height: 10
                            }, 
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(row_Value, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row_Text, {
                            fontSize: [
                                "label",
                                "label",
                                "label",
                                "h2"
                            ],
                            lineHeight: [
                                "label",
                                "label",
                                "label",
                                "h2"
                            ],
                            fontWeight: "bold",
                            color: payload.growthRates === 0 ? "grey_600" : payload.growthRates < 0 ? "red_400" : "lime_400",
                            children: "".concat(payload.growthRates === 0 ? "" : payload.growthRates < 0 ? "-" : "+", " ").concat(Math.abs(payload.growthRates), "%")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "value",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row_Text, {
                    fontSize: [
                        "h3",
                        "h3",
                        "h3",
                        "h2"
                    ],
                    lineHeight: [
                        "h3",
                        "h3",
                        "h3",
                        "h2"
                    ],
                    fontWeight: [
                        "medium",
                        "medium",
                        "medium",
                        "normal"
                    ],
                    color: "grey_600",
                    children: payload.value === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                        width: 50,
                        height: 16,
                        lines: [
                            {
                                x: 0,
                                y: 0,
                                rx: 5,
                                ry: 5,
                                width: 50,
                                height: 12
                            }, 
                        ]
                    }) : payload.value
                })
            })
        ]
    });
}
/* harmony default export */ var row = (Row);

;// CONCATENATED MODULE: ./src/theme/assets-revenue/index.js

function assets_revenue_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n\n  & > .box {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    assets_revenue_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function assets_revenue_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n\n  & > li:last-child {\n    border-bottom: 0px;\n  }\n"
    ]);
    assets_revenue_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var assets_revenue_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cdce49a2-0"
})(assets_revenue_templateObject(), dist_index_esm/* space */.Dh);
var List = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cdce49a2-1"
})(assets_revenue_templateObject1(), dist_index_esm/* space */.Dh, dist_index_esm/* flexbox */.GQ);
function AssetRevenue(param) {
    var title = param.title, id = param.id, payload = param.payload;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(assets_revenue_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                mb: "m",
                fontSize: [
                    "pSmall",
                    "pSmall",
                    "pSmall",
                    "h2"
                ],
                lineHeight: [
                    "pSmall",
                    "pSmall",
                    "pSmall",
                    "h2"
                ],
                fontWeight: "bold",
                color: "grey_600",
                textAlign: "left",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(assets_revenue_chart, {
                        id: id,
                        maxWidth: 200
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                        ml: [
                            "s",
                            "xxl",
                            "xxl",
                            "xxl"
                        ],
                        maxWidth: "208px",
                        width: "100%",
                        bg: "white",
                        border: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                            children: payload.pieChartData.map(function(t) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(row, {
                                    payload: t
                                }, t.label);
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var assets_revenue = (AssetRevenue);

;// CONCATENATED MODULE: ./src/components/assets-revenues-dash/index.js
/* eslint-disable camelcase */ 








function AssetsRevenue(param) {
    var dateTo = param.dateTo, dateFrom = param.dateFrom, dataType = param.dataType, filters = param.filters;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(null), queriedKey = ref[0], setQueriedKey = ref[1];
    var pieAssets = (0,es/* useSelector */.v9)(function(state) {
        return (0,top_assets/* default */.Z)(state, queriedKey);
    });
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }), currency = ref1.currency, languageCode = ref1.languageCode;
    var ref2 = (0,es/* useSelector */.v9)(profile/* default */.Z), isAdminAnalytics = ref2.isAdminAnalytics, analytics_type = ref2.payload.analytics_type;
    var query = (0,react.useMemo)(function() {
        if (!dataType || !dateTo || !dateFrom) return null;
        var queryString = "currency=".concat(currency, "&dataType=").concat(dataType, "&term=item_type&size=10&dateTo=").concat(dateTo, "&dateFrom=").concat(dateFrom, "&version=7&enterprise=").concat(analytics_type || "standard", "&isAdmin=").concat(isAdminAnalytics);
        if (filters) {
            queryString = "".concat(queryString, "&filters=").concat(filters);
        }
        return queryString;
    }, [
        dateTo,
        dateFrom,
        dataType,
        filters,
        currency,
        analytics_type,
        isAdminAnalytics
    ]);
    (0,react.useEffect)(function() {
        if (!query) return;
        var key = base64_default().encode(query);
        setQueriedKey(key);
        dispatch((0,aggr/* getAggrRequest */.js)({
            term: "item_type",
            key: key,
            query: query,
            currency: currency,
            isAdmin: isAdminAnalytics
        }));
    }, [
        dispatch,
        dateTo,
        dateFrom,
        dataType,
        query,
        currency,
        isAdminAnalytics
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(assets_revenue, {
        title: translations/* default */.Z[languageCode]["revenue by assets"],
        payload: pieAssets,
        id: queriedKey
    });
}
/* harmony default export */ var assets_revenues_dash = (AssetsRevenue);

// EXTERNAL MODULE: ./src/redux/reselect/area-chart.js
var area_chart = __webpack_require__(8729);
// EXTERNAL MODULE: ./src/redux/action/histogram.js
var histogram = __webpack_require__(18381);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/victory-chart/es/victory-chart.js + 5 modules
var victory_chart = __webpack_require__(58843);
// EXTERNAL MODULE: ./node_modules/victory-voronoi-container/es/victory-voronoi-container.js + 2 modules
var victory_voronoi_container = __webpack_require__(16098);
// EXTERNAL MODULE: ./node_modules/victory-tooltip/es/victory-tooltip.js + 1 modules
var victory_tooltip = __webpack_require__(77013);
// EXTERNAL MODULE: ./node_modules/victory-axis/es/victory-axis.js + 1 modules
var victory_axis = __webpack_require__(73091);
// EXTERNAL MODULE: ./node_modules/victory-group/es/victory-group.js + 1 modules
var victory_group = __webpack_require__(54878);
// EXTERNAL MODULE: ./node_modules/victory-area/es/victory-area.js + 2 modules
var victory_area = __webpack_require__(42371);
// EXTERNAL MODULE: ./node_modules/react-use-dimensions/es/index.js
var react_use_dimensions_es = __webpack_require__(32941);
;// CONCATENATED MODULE: ./src/theme/charts/area/label.js

function label_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: ",
        ";\n  transform-origin: ",
        ";\n"
    ]);
    label_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var width = 250;
var height = 100;
var label_Wrapper = styled_components_browser_esm/* default.g.withConfig */.ZP.g.withConfig({
    componentId: "sc-ce79f51-0"
})(label_templateObject(), function(param) {
    var isRotate = param.isRotate;
    return isRotate ? "rotate(180deg)" : "rotate(0deg)";
}, function(param) {
    var isRotate = param.isRotate;
    return isRotate ? "".concat(width / 2, "px ").concat(height / 2, "px") : "0px 0px";
});
function Label(param) {
    var maxWidth = param.maxWidth, x = param.x, y = param.y, activePoints = param.activePoints, areaData = param.data;
    var isRotate = (0,react.useMemo)(function() {
        return x > maxWidth / 2;
    }, [
        x,
        maxWidth
    ]);
    var theme = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
    var getLabel = (0,react.useCallback)(function(color) {
        var el = areaData.find(function(row) {
            return (0,index_esm/* themeGet */.R)("colors.".concat(row.color))({
                theme: theme
            }) === color;
        });
        return el && el.label ? el.label : "";
    }, [
        areaData,
        theme
    ]);
    var getValue = (0,react.useCallback)(function(param) {
        var color = param.color, data = param.data;
        if (color === "trasparent") return "";
        var el = areaData.find(function(row) {
            return (0,index_esm/* themeGet */.R)("colors.".concat(row.color))({
                theme: theme
            }) === color;
        });
        if (el && el.id) {
            if (el && el.id === "revenue") {
                return (0,format_currency/* default */.Z)(el.currency, Number(data));
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* FormattedNumber */.BK, {
                value: data
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* FormattedNumber */.BK, {
            value: 0
        });
    }, [
        areaData,
        theme
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        x: "".concat(isRotate ? x - width : x + 5),
        y: "".concat(isRotate ? y - height / 2 - 15 : y - height / 2 + 15),
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(label_Wrapper, {
                isRotate: isRotate,
                stroke: "grey",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                        points: "10,25 0,35 10,45",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: width - 15,
                        height: height,
                        x: "9",
                        rx: "5",
                        ry: "5",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    fill: (0,index_esm/* themeGet */.R)("colors.grey_600")({
                        theme: theme
                    }),
                    style: {
                        whiteSpace: "pre",
                        fontFamily: "inherit",
                        fontSize: "16",
                        letterSpacing: "0px",
                        fontWeight: "bold"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                        x: "100",
                        y: "20",
                        children: activePoints[0].xName
                    })
                })
            }),
            activePoints.map(function(param, index) {
                var childName = param.childName, style = param.style, data = param.y;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "20",
                            r: "5",
                            fill: style.data.stroke,
                            cy: 40 + index * 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("text", {
                            fill: (0,index_esm/* themeGet */.R)("colors.grey_600")({
                                theme: theme
                            }),
                            style: {
                                whiteSpace: "pre",
                                fontFamily: "inherit",
                                fontSize: "14",
                                letterSpacing: "0px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                                    x: "35",
                                    y: "45",
                                    dy: index * 20,
                                    children: "".concat(getLabel(style.data.stroke))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                                    textAnchor: "end",
                                    x: width - 15,
                                    y: "45",
                                    dy: index * 20,
                                    children: getValue({
                                        color: style.data.stroke,
                                        data: data
                                    })
                                })
                            ]
                        })
                    ]
                }, childName);
            })
        ]
    });
}
/* harmony default export */ var label = (Label);

// EXTERNAL MODULE: ./src/theme/checkbox/index.js
var theme_checkbox = __webpack_require__(20324);
;// CONCATENATED MODULE: ./src/theme/charts/area/checkbox.js



function CheckBox(param) {
    var payload = param.payload, onChange = param.onChange;
    var handleChange = (0,react.useCallback)(function(e) {
        var checked = e.target.checked;
        onChange({
            id: payload.id,
            checked: checked
        });
    }, [
        payload,
        onChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_checkbox/* default */.Z, {
        input: {
            onChange: handleChange
        },
        defaultChecked: true,
        meta: {},
        checkColor: payload.color,
        label: payload.label,
        style: {
            ml: "s"
        }
    }, payload.label);
}
/* harmony default export */ var area_checkbox = (CheckBox);

;// CONCATENATED MODULE: ./src/theme/charts/area/index.js





function area_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  z-index: 900;\n\n  .VictoryContainer {\n    & > svg {\n      overflow: visible;\n    }\n  }\n\n  @media only screen and (max-width: 768px) {\n    .VictoryContainer {\n      user-select: auto !important;\n      touch-action: auto !important;\n    }\n  }\n"
    ]);
    area_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function area_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  white-space: nowrap;\n  text-transform: capitalize;\n"
    ]);
    area_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function area_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  & > .checkboxes {\n    display: flex;\n    flex-direction: row;\n  }\n"
    ]);
    area_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var area_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-53c2f167-0"
})(area_templateObject());
var area_Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-53c2f167-1"
})(area_templateObject1(), dist_index_esm/* typography */.cp, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh);
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-53c2f167-2"
})(area_templateObject2(), dist_index_esm/* space */.Dh);
function Area(param) {
    var title = param.title, dateFrom = param.dateFrom, dateTo = param.dateTo, chart = param.payload.chart;
    var ref = (0,react.useState)({}), filter = ref[0], setFilter = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,react_use_dimensions_es/* default */.Z)(), 2), ref2 = ref1[0], width = ref1[1].width;
    var theme = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
    var xAxisLength = (0,react.useMemo)(function() {
        if (chart.length === 0) return 0;
        if (chart[0].data.length <= 6) return 1;
        return Math.round(chart[0].data.length / 6);
    }, [
        chart
    ]);
    var maxAxisY = (0,react.useMemo)(function() {
        if (chart.length === 0) return 0;
        var maxAxis = chart.reduce(function(max, item) {
            return Math.max(max, item.maxAxisY);
        }, -Infinity);
        return maxAxis;
    }, [
        chart
    ]);
    var yAxisPadding = (0,react.useMemo)(function() {
        if (maxAxisY === 0) return 0;
        return -20 - maxAxisY.toString().length * 5;
    }, [
        maxAxisY
    ]);
    var PageWidth = (0,react.useMemo)(function() {
        // Ensure width is a valid finite number
        if (typeof width === "number" && isFinite(width) && width > 0) {
            return width;
        }
        // Fallback to a reasonable default width if width is undefined, Infinity, or invalid
        return 800;
    }, [
        width
    ]);
    var handleChangeFilter = (0,react.useCallback)(function(value) {
        setFilter((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), (0,_define_property/* default */.Z)({}, value.id, value.checked)));
    }, [
        filter
    ]);
    (0,react.useEffect)(function() {
        var filterObj = {};
        chart.forEach(function(el) {
            filterObj = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterObj), (0,_define_property/* default */.Z)({}, el.id, true));
        });
        setFilter(filterObj);
    }, [
        chart
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(area_Wrapper, {
        ref: ref2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                px: "s",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(area_Text, {
                                fontSize: [
                                    "pSmall",
                                    "pSmall",
                                    "pSmall",
                                    "h2"
                                ],
                                lineHeight: [
                                    "pSmall",
                                    "pSmall",
                                    "pSmall",
                                    "h2"
                                ],
                                fontWeight: "bold",
                                color: "grey_600",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(area_Text, {
                                fontSize: [
                                    "pSmall",
                                    "pSmall",
                                    "pSmall",
                                    "pLarge"
                                ],
                                lineHeight: [
                                    "pSmall",
                                    "pSmall",
                                    "pSmall",
                                    "pLarge"
                                ],
                                fontWeight: "normal",
                                color: "grey_400",
                                children: [
                                    dateFrom,
                                    " -",
                                    dateTo
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "checkboxes",
                        children: chart.map(function(el) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(area_checkbox, {
                                payload: el,
                                onChange: handleChangeFilter
                            }, el.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(victory_chart/* VictoryChart */.k, {
                height: 350,
                width: PageWidth,
                animate: {
                    duration: 1000
                },
                domainPadding: {
                    x: 0,
                    y: 30
                },
                containerComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_voronoi_container/* default */.Z, {
                    voronoiBlacklist: [
                        "parent"
                    ],
                    voronoiDimension: "x",
                    labels: function() {
                        return " ";
                    },
                    labelComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_tooltip/* default */.Z, {
                        cornerRadius: 4,
                        flyoutStyle: {
                            fill: "white",
                            stroke: "transparent"
                        },
                        style: {
                            fontSize: 13,
                            fontFamily: "inherit",
                            lineHeight: "20px",
                            fill: (0,index_esm/* themeGet */.R)("colors.grey_600")({
                                theme: theme
                            })
                        },
                        flyoutComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(label, {
                            data: chart,
                            maxWidth: PageWidth
                        })
                    })
                }),
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 50
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_axis/* VictoryAxis */.E, {
                        tickFormat: function(t, index) {
                            return index % xAxisLength === 0 ? t : "";
                        },
                        style: {
                            axis: {
                                stroke: "transparent"
                            },
                            tickLabels: {
                                fontFamily: "inherit",
                                fontSize: 13,
                                padding: 12,
                                angle: 35,
                                verticalAnchor: "end",
                                textAnchor: "start"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_axis/* VictoryAxis */.E, {
                        dependentAxis: true,
                        style: {
                            grid: {
                                stroke: "grey",
                                strokeDasharray: "4, 8",
                                strokeWidth: 0.5
                            },
                            axis: {
                                stroke: "transparent"
                            },
                            tickLabels: {
                                fontFamily: "inherit",
                                textAnchor: "end",
                                fontSize: 13,
                                padding: yAxisPadding
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_group/* VictoryGroup */.G, {
                        style: {
                            data: {
                                strokeWidth: 2,
                                fillOpacity: 0.5
                            }
                        },
                        children: chart.map(function(el) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_area/* VictoryArea */.b, {
                                style: {
                                    data: {
                                        fill: filter[el.id] ? (0,index_esm/* themeGet */.R)("colors.".concat(el.color))({
                                            theme: theme
                                        }) : "trasparent",
                                        stroke: filter[el.id] ? (0,index_esm/* themeGet */.R)("colors.".concat(el.color))({
                                            theme: theme
                                        }) : "trasparent"
                                    }
                                },
                                data: el.data,
                                // data accessor for x values
                                x: "date",
                                y: function(d) {
                                    return filter[el.id] ? d.y : 0;
                                },
                                interpolation: "natural"
                            }, el.color);
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var charts_area = (Area);

// EXTERNAL MODULE: ./src/theme/content-loader/area.js
var content_loader_area = __webpack_require__(57290);
;// CONCATENATED MODULE: ./src/components/area-chart/index.js



function area_chart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n"
    ]);
    area_chart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function area_chart_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n"
    ]);
    area_chart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var area_chart_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13864cb1-0"
})(area_chart_templateObject(), dist_index_esm/* space */.Dh);
var WrapLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13864cb1-1"
})(area_chart_templateObject1());
function AreaChart(param) {
    var style = param.style, dateTo = param.dateTo, dateFrom = param.dateFrom, dataType = param.dataType, dateRange = param.dateRange, filters = param.filters, interval = param.interval;
    var ref = (0,react.useState)(null), queriedKey = ref[0], setQueriedKey = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }), currency = ref1.currency, languageCode = ref1.languageCode;
    var areaPoints = (0,es/* useSelector */.v9)(function(state) {
        return (0,area_chart/* default */.Z)(state, queriedKey);
    });
    var analytics_type = (0,es/* useSelector */.v9)(function(state) {
        return state.profile.payload;
    }).analytics_type;
    // Fallback per dateRange se è undefined
    var safeDateRange = dateRange || "custom";
    var query = (0,react.useMemo)(function() {
        if (!dataType || !dateTo || !dateFrom || !interval) return null;
        var queryString = "interval=".concat(interval, "&currency=").concat(currency, "&dateRange=").concat(safeDateRange, "&dateTo=").concat(dateTo, "&dateFrom=").concat(dateFrom, "&dataType=").concat(dataType, "&version=7&enterprise=").concat(analytics_type || "standard");
        if (filters) {
            queryString = "".concat(queryString, "&filters=").concat(filters);
        }
        return queryString;
    }, [
        dateTo,
        dateFrom,
        dataType,
        filters,
        currency,
        interval,
        analytics_type
    ]);
    var filteredAreaPoints = (0,react.useMemo)(function() {
        if (!areaPoints) return null;
        var filteredChart = dataType === "usage_data" ? areaPoints.chart.filter(function(point) {
            return !point.id.match(/revenue/);
        }) : areaPoints.chart.filter(function(point) {
            return !point.id.match(/duration/);
        });
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, areaPoints), {
            chart: filteredChart
        });
    }, [
        areaPoints,
        dataType
    ]);
    (0,react.useEffect)(function() {
        if (!query) return;
        var key = base64_default().encode(query);
        setQueriedKey(key);
        dispatch((0,histogram/* getHistogramRequest */.ec)({
            key: key,
            query: query,
            currency: currency
        }));
    }, [
        dispatch,
        query,
        currency
    ]);
    var formatDates = (0,react.useMemo)(function() {
        moment_default().locale(languageCode);
        return {
            dateFrom: moment_default()(dateFrom).format("DD MMM YYYY"),
            dateTo: moment_default()(dateTo).format("DD MMM YYYY")
        };
    }, [
        dateFrom,
        dateTo,
        languageCode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(area_chart_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
        children: [
            filteredAreaPoints.chart.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_area, {
                title: translations/* default */.Z[languageCode]["Last 30 days"],
                dateTo: formatDates.dateTo,
                dateFrom: formatDates.dateFrom,
                payload: filteredAreaPoints
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader_area/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapLink, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_link, {
                        href: "/analytics",
                        style: {
                            mt: "s"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            fontSize: [
                                "pSmall",
                                "pSmall",
                                "pSmall",
                                "pLarge"
                            ],
                            lineHeight: [
                                "pSmall",
                                "pSmall",
                                "pSmall",
                                "pLarge"
                            ],
                            fontWeight: [
                                "normal",
                                "normal",
                                "normal",
                                "medium"
                            ],
                            textAlign: "center",
                            children: translations/* default */.Z[languageCode]["go to the analytics section"]
                        })
                    })
                })
            })
        ]
    }));
}
/* harmony default export */ var components_area_chart = (AreaChart);

// EXTERNAL MODULE: ./src/components/top-bar/index.js
var top_bar = __webpack_require__(32095);
;// CONCATENATED MODULE: ./src/pages/home/index.js

function home_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  /* Below the first breakpoint the two columns stop being columns: on a phone\n     the right-hand one (add content, services, history, top selling) squeezed\n     the charts into a strip. Stacked, nothing is lost and nothing is cramped. */\n  .row {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  @media (min-width: ",
        ") {\n    .row {\n      flex-direction: row;\n    }\n  }\n"
    ]);
    home_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function home_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n"
    ]);
    home_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function home_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  /* A phone cannot hold three cards side by side: each of them was a third of\n     the screen, so the figures spilled over their own card and the page\n     scrolled sideways. Stacked below the first breakpoint, side by side above. */\n  flex-direction: column;\n  justify-content: center;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    home_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function home_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n\n  & > div:first-child {\n    flex: 1;\n  }\n"
    ]);
    home_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



















var home_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0c5b3-0"
})(home_templateObject(), (0,index_esm/* themeGet */.R)("breakpoints.0"));
var home_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0c5b3-1"
})(home_templateObject1(), dist_index_esm/* space */.Dh);
var home_Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0c5b3-2"
})(home_templateObject2(), dist_index_esm/* space */.Dh, dist_index_esm/* color */.$_, dist_index_esm/* layout */.bK, (0,index_esm/* themeGet */.R)("breakpoints.0"));
var WrapStats = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0c5b3-3"
})(home_templateObject3(), dist_index_esm/* flexbox */.GQ);
function DashboardPage() {
    var formatDate = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).formatDate;
    var dateTo = (0,react.useMemo)(function() {
        var today = moment_default()();
        return today.format(formatDate);
    }, [
        formatDate
    ]);
    var dateFrom = (0,react.useMemo)(function() {
        var today = moment_default()();
        return today.subtract(30, "days").format(formatDate);
    }, [
        formatDate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_switch/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(home_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                    bg: "white",
                    title: "StreetLib Dashboard"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(home_Content, {
                            pb: "m",
                            px: "s",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_Section, {
                                    maxWidth: "1440px",
                                    width: "100%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warning_notification/* default */.Z, {
                                        style: {
                                            p: "s",
                                            mb: "m"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_Section, {
                                    mb: "m",
                                    width: "100%",
                                    maxWidth: "1440px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(counter_cards, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_Section, {
                                    mb: "m",
                                    width: "100%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                        width: "100%",
                                        bg: "primary_50",
                                        border: "none",
                                        py: "m",
                                        px: "s",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(scope_gate, {
                                            section: "analytics",
                                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(locked_section, {
                                                width: "100%",
                                                minHeight: "280px"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapStats, {
                                                flexDirection: [
                                                    "column",
                                                    "column",
                                                    "column",
                                                    "column",
                                                    "row"
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                                        width: [
                                                            "100%",
                                                            "100%",
                                                            "100%",
                                                            "100%",
                                                            "50%"
                                                        ],
                                                        bg: "white",
                                                        border: "none",
                                                        py: "m",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_area_chart, {
                                                            interval: "day",
                                                            dateTo: dateTo,
                                                            dateFrom: dateFrom,
                                                            dataType: "temporary_data"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                                        width: [
                                                            "100%",
                                                            "100%",
                                                            "100%",
                                                            "100%",
                                                            "50%"
                                                        ],
                                                        bg: "white",
                                                        border: "none",
                                                        py: "m",
                                                        px: "s",
                                                        mt: [
                                                            "s",
                                                            "s",
                                                            "s",
                                                            "s",
                                                            "0"
                                                        ],
                                                        ml: [
                                                            "0",
                                                            "0",
                                                            "0",
                                                            "0",
                                                            "s"
                                                        ],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets_revenues_dash, {
                                                            dateTo: dateTo,
                                                            dateFrom: dateFrom,
                                                            dataType: "temporary_data"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(home_Section, {
                                    mb: "m",
                                    width: "100%",
                                    maxWidth: "1440px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(news_cards, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar, {})
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var home = (DashboardPage);


/***/ }),

/***/ 20324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32808);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 320px;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  flex: 1;\n\n  & > .ant-checkbox-wrapper {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    color: rgba(0, 0, 0, 0.65);\n    font-size: 14px;\n    font-variant: tabular-nums;\n    list-style: none;\n    font-feature-settings: 'tnum';\n    display: inline-block;\n    line-height: unset;\n    cursor: pointer;\n  }\n\n  & > .ant-checkbox-wrapper > .ant-checkbox {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    color: rgba(0, 0, 0, 0.65);\n    font-size: 14px;\n    font-variant: tabular-nums;\n    list-style: none;\n    font-feature-settings: 'tnum';\n    position: relative;\n    top: -0.09em;\n    display: inline-block;\n    line-height: 1;\n    white-space: nowrap;\n    vertical-align: middle;\n    outline: none;\n    cursor: pointer;\n    border: 2px solid ",
        ";\n    border-radius: 2px;\n  }\n\n  & > .ant-checkbox-wrapper > .ant-checkbox-checked::after {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 1px solid #1890ff;\n    border-radius: 2px;\n    visibility: hidden;\n    animation: antCheckboxEffect 0.36s ease-in-out;\n    animation-fill-mode: backwards;\n    content: '';\n  }\n\n  & > .ant-checkbox-wrapper > .ant-checkbox > .ant-checkbox-input {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    opacity: 0;\n  }\n\n  & > .ant-checkbox-wrapper > .ant-checkbox > .ant-checkbox-inner {\n    position: relative;\n    top: 0;\n    left: 0;\n    display: block;\n    width: 18px;\n    height: 18px;\n    background-color: #fff;\n    border-collapse: separate;\n    transition: all 0.3s;\n    border-radius: 0;\n    border: none;\n\n    &:after {\n      position: absolute;\n      top: 50%;\n      left: 21%;\n      display: table;\n      width: 7px;\n      height: 14px;\n      border: 2px solid #fff;\n      border-top: 0;\n      border-left: 0;\n      transform: rotate(45deg) scale(0) translate(-50%, -50%);\n      opacity: 0;\n      transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;\n      content: ' ';\n    }\n  }\n\n  & > .ant-checkbox-wrapper > .ant-checkbox-checked > .ant-checkbox-inner {\n    background-color: ",
        ";\n\n    &:after {\n      position: absolute;\n      display: table;\n      transform: rotate(45deg) scale(1) translate(-50%, -50%);\n      opacity: 1;\n      transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n      content: ' ';\n    }\n  }\n\n  & > .ant-checkbox-wrapper > .ant-checkbox-checked {\n    &:after {\n      border: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  display: flex;\n  width: 100%;\n  align-items: baseline;\n  line-height: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  line-height: 1.5em;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9aee2af7-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK);
var Label = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-9aee2af7-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp);
var WrapCheckbox = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9aee2af7-2"
})(_templateObject2(), function(param) {
    var checkColor = param.checkColor;
    return (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.".concat(checkColor || "grey_400"));
}, function(param) {
    var checkColor = param.checkColor;
    return (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.".concat(checkColor || "grey_400"));
});
var WrapError = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9aee2af7-3"
})(_templateObject3(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_);
var Message = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-9aee2af7-4"
})(_templateObject4(), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh);
function MyCheckbox(param) {
    var fontSize = param.fontSize, defaultChecked = param.defaultChecked, checkColor = param.checkColor, disabled = param.disabled, style = param.style, input = param.input, meta = param.meta, size = param.size, label = param.label, error = param.error;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, style), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WrapCheckbox, {
                size: size,
                checkColor: disabled ? "primary_200" : checkColor,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, input), {
                        onChange: input.onChange,
                        defaultChecked: defaultChecked,
                        disabled: disabled
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                        fontSize: fontSize || [
                            "pSmall",
                            "pSmall",
                            "pSmall",
                            "h3"
                        ],
                        lineHeight: [
                            "pSmall",
                            "pSmall",
                            "pSmall",
                            "h3"
                        ],
                        fontWeight: "normal",
                        color: "grey_600",
                        ml: "xs",
                        dangerouslySetInnerHTML: {
                            __html: label
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapError, {
                color: "red_400",
                children: meta.error && meta.touched && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Message, {
                    m: 0,
                    fontSize: 1,
                    children: error
                })
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (MyCheckbox);


/***/ }),

/***/ 62878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function InfoCircle(param) {
    var _width = param.width, width = _width === void 0 ? "19" : _width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        viewBox: "0 0 19 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.00586 5.61328C8.53987 5.61328 8.16211 5.99104 8.16211 6.45703C8.16211 6.92302 8.53987 7.30078 9.00586 7.30078C9.47185 7.30078 9.84961 6.92302 9.84961 6.45703C9.84961 5.99104 9.47185 5.61328 9.00586 5.61328Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.25586 12.9258C8.25586 13.34 8.59165 13.6758 9.00586 13.6758C9.42007 13.6758 9.75586 13.34 9.75586 12.9258L9.75586 8.98828C9.75586 8.57407 9.42007 8.23828 9.00586 8.23828C8.59164 8.23828 8.25586 8.57407 8.25586 8.98828L8.25586 12.9258Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.5059 9.55078C16.5059 13.6929 13.148 17.0508 9.00586 17.0508C4.86372 17.0508 1.50586 13.6929 1.50586 9.55078C1.50586 5.40865 4.86372 2.05078 9.00586 2.05078C13.148 2.05078 16.5059 5.40865 16.5059 9.55078ZM9.00586 15.5508C12.3196 15.5508 15.0059 12.8645 15.0059 9.55078C15.0059 6.23707 12.3196 3.55078 9.00586 3.55078C5.69215 3.55078 3.00586 6.23707 3.00586 9.55078C3.00586 12.8645 5.69215 15.5508 9.00586 15.5508Z",
                fill: "currentColor"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (InfoCircle);


/***/ }),

/***/ 41396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Lock(param) {
    var width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width || "18",
        viewBox: "0 0 18 19",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_4413:18679hh8)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.9998 0.267578C6.5185 0.267578 4.4998 2.28628 4.4998 4.76758V7.46758H3.5998C2.6071 7.46758 1.7998 8.27488 1.7998 9.26758V16.4676C1.7998 17.4603 2.6071 18.2676 3.5998 18.2676H14.3998C15.3925 18.2676 16.1998 17.4603 16.1998 16.4676V9.26758C16.1998 8.27488 15.3925 7.46758 14.3998 7.46758H13.4998V4.76758C13.4998 2.28628 11.4811 0.267578 8.9998 0.267578ZM14.3998 9.26758L14.4016 16.4676H3.5998V9.26758H14.3998ZM6.2998 7.46758V4.76758C6.2998 3.27898 7.5112 2.06758 8.9998 2.06758C10.4884 2.06758 11.6998 3.27898 11.6998 4.76758V7.46758H6.2998Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_4413:18679hh8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(0 0.267578)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Lock);


/***/ }),

/***/ 54469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14141);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50056);
/* eslint-disable react-hooks/rules-of-hooks */ 



var write = function(param) {
    var disabled = param.disabled, _width = param.width, width = _width === void 0 ? "18" : _width, color = param.color;
    var theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__/* .ThemeContext */ .Ni);
    var colorMemo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (color) {
            return (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_2__/* .themeGet */ .R)("colors.".concat(color))({
                theme: theme
            });
        }
        return disabled ? "grey_200" : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_2__/* .themeGet */ .R)("colors.write")({
            theme: theme
        });
    }, [
        theme,
        disabled,
        color
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.17702 13.8958L4.15285 13.9095V9.86981L12.938 1.16855C13.6219 0.485548 14.8247 0.4819 15.5141 1.17129L16.9603 2.61755C17.305 2.96224 17.4947 3.42001 17.4947 3.90696C17.4947 4.39391 17.305 4.85168 16.9603 5.19637L8.17702 13.8958ZM15.6737 3.90422L14.2247 2.4607L12.7711 3.90149L14.2174 5.34683L15.6737 3.90422ZM11.4753 5.1836L5.97663 10.6303V12.0793L7.4238 12.0748L12.9216 6.62986L11.4753 5.1836ZM15.0955 17.5452H2.32909C1.32328 17.5452 0.50531 16.7273 0.50531 15.7214V2.95499C0.50531 1.94917 1.32328 1.13121 2.32909 1.13121H10.3966L8.5728 2.95499H2.32909V15.7214H5.04561C5.06034 15.7219 5.07486 15.724 5.08927 15.726C5.1052 15.7283 5.121 15.7306 5.1368 15.7306C5.14865 15.7306 5.16074 15.7283 5.17282 15.726C5.1849 15.7237 5.19698 15.7214 5.20884 15.7214H15.0955V9.64096L16.9193 7.81718V15.7214C16.9193 16.7273 16.1014 17.5452 15.0955 17.5452Z",
                    fill: colorMemo
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(0 0.100098)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (write);


/***/ }),

/***/ 55431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14141);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: transparent;\n  outline: 0;\n  text-decoration: none;\n  display: flex;\n\n  & > span {\n    color: ",
        ";\n    border-radius: 12px;\n\n    width: 100%;\n\n    ",
        "\n\n    display: flex;\n    justify-content: center;\n\n    &:hover {\n      color: ",
        ";\n    }\n\n    &:focus {\n      color: ",
        ";\n    }\n  }\n\n  &:focus {\n    color: transparent;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Button = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-5cc0fe7b-0"
})(_templateObject(), function(param) {
    var isFocused = param.isFocused;
    return isFocused ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_600") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_400");
}, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_500"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_600"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK);
function ExternalLink(_param) {
    var style = _param.style, label = _param.label, disabled = _param.disabled, isWaiting = _param.isWaiting, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "style",
        "label",
        "disabled",
        "isWaiting"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        title: label,
        "aria-label": label,
        fontSize: "h4",
        lineHeight: "h4",
        fontWeight: "bold"
    }, style), {
        disabled: disabled || isWaiting
    }), rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            children: label
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ExternalLink);


/***/ }),

/***/ 4509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24762);






function CustomTooltip(_param) {
    var text = _param.text, forData = _param.forData, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "forData"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: forData,
        "aria-haspopup": "true"
    }, others), {
        children: text
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (CustomTooltip);


/***/ })

}]);